{
  "de": {
    "labels": {
      "saved": "Gespeichert",
      "hangarShare": {
        "intro": "Erstelle einen geheimen Link, der deinen Hangar und seine Statistiken allen zeigt, denen du ihn gibst – auch wenn dein Hangar privat ist. Deine Wunschliste behält ihre eigene Einstellung.",
        "howTo": "Jeder mit diesem Link kann deinen Hangar sehen. Erneuere ihn, um alle mit dem aktuellen Link auszusperren, oder lösche ihn, um das Teilen zu beenden."
      },
      "locationInput": {
        "linked": "Verknüpft mit"
      },
      "galactapedia": "Galactapedia",
      "shopPage": {
        "all": "Alle",
        "search": "In diesem Shop suchen",
        "categories": "Kategorien",
        "sortName": "Name",
        "sortPrice": "Preis",
        "emptyName": "Artikel",
        "kind": "Laden",
        "items": "Artikel",
        "facts": "Eckdaten",
        "place": "Ort",
        "system": "System",
        "carries": "Verkauft",
        "source": "Preise und Sortiment von UEX."
      },
      "location": {
        "missionsSample": "Die Zahlen beziehen sich auf die ersten %{shown} von %{total}.",
        "people": "Freunde & Flotte hier",
        "peopleFriend": "Freund",
        "peopleUnlisted": "%{count} weitere nicht aufgeführt",
        "systemUnavailable": "Dieses System konnte nicht geladen werden.",
        "systemsUnavailable": "Die Systeme konnten nicht geladen werden.",
        "resourceKinds": {
          "ship_mineables": "Schiffsabbau",
          "hand_mineables": "Handabbau",
          "ground_vehicle_mineables": "Bodenfahrzeug-Abbau",
          "harvestables": "Erntegut",
          "creatures": "Kreaturen"
        },
        "resources": "Ressourcen",
        "moonsBadge": "Monde",
        "planets": "Planeten",
        "places": "Orte",
        "showFewer": "Weniger anzeigen",
        "showAll": "Alle %{count} anzeigen",
        "elsewhere": "Sonst um %{star}",
        "namesakes": "×%{count}",
        "lagrangePoints": "Lagrange-Punkte",
        "inOrbit": "Im Orbit",
        "moons": {
          "one": "%{count} Mond",
          "other": "%{count} Monde"
        },
        "gateways": "Sprungtore",
        "jumpPoints": "Sprungpunkte",
        "notInGameYet": "Noch nicht im Spiel",
        "jumpLegend": {
          "title": "Sprungverbindungen",
          "inGame": "Im Spiel",
          "temporary": "Vorläufig",
          "planned": "Geplant"
        },
        "systemStrip": "%{system}, vom Stern nach außen",
        "allSystems": "Alle Systeme",
        "allPlaces": "Alle Orte",
        "shops": "Läden",
        "shopItems": {
          "one": "%{count} Artikel",
          "other": "%{count} Artikel"
        },
        "shopItemTypes": {
          "Model": "Schiff",
          "ModelModule": "Modul",
          "ModelPaint": "Lackierung",
          "Component": "Komponente",
          "Equipment": "Ausrüstung",
          "Commodity": "Ware"
        },
        "bodyTypes": {
          "gas_giant": "Gasriese",
          "ice_giant": "Eisriese",
          "asteroid": "Asteroid",
          "city": "Stadtplanet"
        },
        "unstable": "Instabil",
        "unstableHint": "Ein Flare-Stern: Seine Strahlung schießt ohne Vorwarnung in die Höhe.",
        "systems": "Sternsysteme",
        "name": "Name",
        "kind": "Art",
        "retired": "Nicht in diesem Build",
        "starmap": "Sternenkarte",
        "starmapVisibility": "Karte im Spiel",
        "starmapHidden": "Auf der Karte verborgen",
        "starmapAlways": "Immer auf der Karte sichtbar",
        "starmapWithParent": "Sichtbar, sobald %{parent} ausgewählt ist",
        "starmapShown": "Auf der Karte sichtbar",
        "quantumTravel": "Quantenreise",
        "quantumTravelYes": "Ja",
        "quantumTravelNo": "Nein",
        "mapParent": "Eingezeichnet unter",
        "mapParentNote": "Die Karte im Spiel zeigt den Ort unter %{mapParent}, obwohl er in %{parent} liegt.",
        "missions": "Missionen",
        "allMissions": "Alle Missionen, die hier stattfinden können",
        "terminals": "Handelsterminals",
        "alwaysShown": "Immer auf der Karte",
        "hiddenOnStarmap": "Auf der Karte verborgen",
        "facilities": "Landen",
        "hangars": "Hangars",
        "hangarsNote": "Jeder Hangar wird pro Pilot instanziert: gezählt werden Tore, nicht Stellplätze.",
        "landingPads": "Landeplätze",
        "freeLandingPads": "Freie Landeplätze",
        "freeLandingPadsNote": "Landung ohne Zuweisung durch die Flugsicherung.",
        "vehiclePads": "Landeplätze für Bodenfahrzeuge",
        "dockingTubes": "Andockschleusen",
        "kinds": {
          "system": "Sternsystem",
          "star": "Stern",
          "planet": "Planet",
          "moon": "Mond",
          "city": "Stadt",
          "spaceport": "Raumhafen",
          "station": "Station",
          "outpost": "Außenposten",
          "clinic": "Klinik",
          "district": "Bezirk",
          "asteroid": "Asteroid",
          "anomaly": "Anomalie",
          "jump_point": "Sprungpunkt",
          "point_of_interest": "Ort von Interesse",
          "nav_point": "Navigationspunkt",
          "other": "Sonstiges"
        },
        "setLocation": "Standort setzen",
        "myLocation": "Mein Standort",
        "shipLocation": "Standort eines Schiffs",
        "setLocationSuccess": "Standort aktualisiert.",
        "setLocationFailure": "Standort konnte nicht aktualisiert werden."
      },
      "sortOptions": "Sortieroptionen",
      "loading": "Lädt…",
      "loadingNamed": "%{name} wird geladen…",
      "true": "Ja",
      "false": "Nein",
      "null": "-",
      "presets": {
        "title": "Bild auswählen",
        "filter": "Typ",
        "all": "Alle",
        "empty": "Keine Bilder verfügbar."
      },
      "maintainer": {
        "badge": "Maintainer",
        "tooltip": "Betreut FleetYards.net"
      },
      "supporter": {
        "badge": "Unterstützer",
        "tooltip": "Unterstützt FleetYards.net diesen Monat",
        "none": "Kein Unterstützer",
        "fleetTierUntil": "Flotten-Stufe bis %{date}",
        "fleetTierExpired": "Abgelaufen",
        "fleetTierOngoing": "Flotten-Stufe, solange das Abo läuft",
        "until": "Aktiv bis %{date}",
        "expiring": "Läuft am %{date} ab",
        "ongoing": "Wiederkehrend, ohne Enddatum",
        "tierShort": "Stufe %{tier}"
      },
      "destroyedFleets": {
        "discarded": "Verworfen",
        "purged": "Endgültig gelöscht"
      },
      "and": "und",
      "hide": "Verbergen",
      "show": "Anzeigen",
      "only": "Nur",
      "description": "Beschreibung",
      "unavailable": "nicht verfügbar",
      "selected": "Ausgewählt",
      "actions": "Aktionen",
      "status": "Status",
      "enabled": "Aktiviert",
      "disabled": "Deaktiviert",
      "collapse": "Einklappen",
      "price": "Preis",
      "expand": "Ausklappen",
      "distance": "Entfernung",
      "anonymous": "Anonym",
      "refreshing": "Wird aktualisiert...",
      "toggleNavigation": "Navigation umschalten",
      "openInNewWindow": "Im Vollbild öffnen",
      "or": "oder",
      "groups": "Gruppen",
      "classifications": "Klassifizierungen",
      "features": {
        "stateOn": "Aktiviert",
        "stateOff": "Deaktiviert",
        "stateConditional": "Bedingt",
        "openFor": "Seit %{days} Tagen offen",
        "historyEmpty": "Für dieses Feature wurde noch nichts aufgezeichnet.",
        "historyBy": "von %{actor}",
        "sources": {
          "admin": "Admin",
          "self_service": "Selbstbedienung",
          "sync": "Deployment",
          "console": "Konsole",
          "backfill": "Nachgetragen"
        },
        "selfService": "Self-Service",
        "actors": "Akteure",
        "groups": "Gruppen",
        "noGroups": "Keine Gruppen für diese Funktion aktiviert.",
        "noActors": "Keine einzelnen Akteure für diese Funktion aktiviert.",
        "user": "Benutzer",
        "fleet": "Flotte",
        "actorType": "Akteurtyp",
        "percentageOfActors": "der Akteure",
        "percentageOfTime": "der Zeit",
        "currentState": "Aktueller Status",
        "toggle": "Umschalten",
        "permanent": "Dauerhaft",
        "tabs": {
          "all": "Alle",
          "rollout": "Rollout",
          "permanent": "Dauerhaft"
        },
        "settingsIntro": "Aktivieren oder deaktivieren Sie experimentelle Funktionen für Ihr Konto. Diese Funktionen können unvollständig sein oder sich ohne Vorankündigung ändern.",
        "registryHint": "Flags werden in config/feature_flags.yml deklariert und beim Deploy erstellt. Hier steuerst du ihre Gates.",
        "fleetSettingsIntro": "Aktivieren oder deaktivieren Sie Funktionen für die gesamte Flotte. Was Sie hier einschalten, sehen alle Mitglieder.",
        "fleetFeature": "Flottenfunktion",
        "fleetFeatureInfo": "Hier eingeschaltet gilt sie nur für Sie. Die Admins Ihrer Flotte können sie für die gesamte Flotte aktivieren.",
        "toggleForSelf": "Nur für Sie umschalten",
        "fleetFeatureGrantedShort": "Von Flotte aktiviert",
        "fleetFeatureGranted": "Ihre Flotte hat dies für alle Mitglieder aktiviert, daher kann es hier nicht abgeschaltet werden.",
        "groupFeatureGrantedShort": "Von Gruppe aktiviert",
        "groupFeatureGranted": "Eine Gruppe, in der Sie sind, hat diese Funktion aktiviert, daher kann sie hier nicht abgeschaltet werden.",
        "groupFeatureGrantedFleet": "Eine Gruppe, in der diese Flotte ist, hat diese Funktion aktiviert, daher kann sie hier nicht abgeschaltet werden.",
        "managedFeatureShort": "Verwaltet",
        "managedFeature": "Diese Funktion wurde für Ihr Konto aktiviert und kann hier nicht geändert werden.",
        "managedFeatureFleet": "Diese Funktion wurde für diese Flotte aktiviert und kann hier nicht geändert werden.",
        "selfServiceUser": "Benutzer können umschalten",
        "selfServiceFleet": "Flotten-Admins können umschalten",
        "globalHint": "Ein öffnet die Funktion für alle. Aus entfernt jede Freigabe, auch die Benutzer, Flotten und Gruppen weiter unten.",
        "selfServiceHint": "Wer diese Funktion selbst einschalten darf.",
        "lastChanged": "Zuletzt geändert %{date}",
        "filterUsers": "Nach Benutzername filtern",
        "filterFleets": "Nach Name oder SID filtern",
        "noUsers": "Kein Benutzer hat diese Funktion einzeln aktiviert.",
        "noFleets": "Keine Flotte hat diese Funktion einzeln aktiviert.",
        "noMatches": "Nichts passt zum Filter.",
        "memberCount": "%{count} Mitglieder",
        "alreadyEnabled": "Diese Flotte hat die Funktion bereits."
      },
      "oauthApplication": {
        "name": "Anwendungsname",
        "clientId": "Client-ID",
        "clientSecret": "Client-Secret",
        "redirectUri": "Weiterleitungs-URI",
        "redirectUriHint": "Verwenden Sie eine URI pro Zeile.",
        "confidential": "Vertraulich",
        "scopes": "Berechtigungen",
        "scopesHint": "Wenn keine Berechtigungen ausgewählt sind, werden die Standardberechtigungen verwendet: %{scopes}",
        "logo": "Logo",
        "logoHint": "Wird auf der Zustimmungsseite angezeigt, damit Nutzer deine Anwendung erkennen. PNG, JPG, GIF oder WebP."
      },
      "rsiRequestLogs": {
        "resolved": "Gelöst",
        "unresolved": "Ungelöst"
      },
      "imports": {
        "type": "Typ",
        "status": "Status",
        "version": "Version",
        "startedAt": "Gestartet",
        "finishedAt": "Beendet",
        "failedAt": "Fehlgeschlagen am",
        "info": "Info",
        "input": "Eingabe",
        "output": "Ausgabe",
        "importData": "Importdaten",
        "file": "Importierte Datei",
        "requestedBy": "Angefordert von",
        "adminUser": "Admin Benutzer",
        "user": "Benutzer",
        "includeSystem": "System einschließen",
        "systemRequester": "System",
        "statuses": {
          "created": "Wartend",
          "started": "Läuft",
          "finished": "Abgeschlossen",
          "failed": "Fehlgeschlagen",
          "cancelled": "Abgebrochen"
        },
        "targetGroupHint": "Wähle eine Hangar-Gruppe, dann landet jedes importierte Schiff darin. Leer lassen, um die Gruppen aus der Datei zu verwenden.",
        "types": {
          "Imports::HangarImport": "Hangar-Import",
          "Imports::HangarSync": "RSI-Hangar-Sync",
          "Imports::BuybackSync": "RSI-Rückkauf-Sync"
        },
        "summary": {
          "imported": "Importiert",
          "missing": "Nicht gefunden",
          "found": "Zugeordnet"
        },
        "formatHint": "Drei Dateiformate werden akzeptiert:",
        "formats": {
          "fleetyards": "Ein FleetYards-Hangar-Export — nutze dafür den Export-Button.",
          "hangarXplor": "Ein hangarXPLOR-Export.",
          "hangarExtension": "Ein JSON-Export der Browser-Erweiterung Star Citizen: Hangar Extension."
        },
        "details": {
          "imported": "Hinzugefügt",
          "found": "Zugeordnet",
          "movedToWanted": "Auf die Wunschliste verschoben",
          "deleted": "Gelöscht",
          "grouped": "In eine Gruppe einsortiert",
          "unchanged": "Unverändert gelassen",
          "missing": "Schiffe nicht gefunden",
          "missingComponents": "Komponenten nicht gefunden",
          "missingUpgrades": "Upgrades nicht gefunden"
        },
        "noDetails": "Dieser Lauf hat keine Details aufgezeichnet."
      },
      "oauthApplications": {
        "settingsIntro": "Verwalten Sie Ihre OAuth-Anwendungen. Diese Anwendungen können im Namen von Benutzern auf die FleetYards-API zugreifen.",
        "name": "Anwendungsname",
        "redirectUri": "Weiterleitungs-URI",
        "confidential": "Vertraulich",
        "clientId": "Client-ID",
        "clientSecret": "Client-Secret",
        "scopes": "Berechtigungen",
        "defaultScopes": "Standard-Berechtigungen",
        "confidentialShort": "Vertraulich",
        "publicShort": "Öffentlich",
        "logo": "Logo",
        "state": "Status",
        "rejectionReason": "Ablehnungsgrund",
        "statePending": "Wartet auf Prüfung",
        "stateApproved": "Freigegeben",
        "stateRejected": "Abgelehnt",
        "reviewedBy": "Geprüft von",
        "owner": "Registriert von"
      },
      "fleetInviteToken": "Flotteneinladung",
      "inviteToken": "Einladungscode",
      "scDataVersion": "Patch-Version",
      "title": "Titel",
      "createdAt": "Erstellt am",
      "updatedAt": "Aktualisiert am",
      "addToHangar": "Zum Hangar hinzufügen",
      "home": {
        "catalogueSearch": "Schiffe, Gegenstände, Missionen und Orte suchen",
        "submitCatalogueSearch": "Suchen",
        "search": "Schiffe suchen...",
        "submitSearch": "Schiffe suchen"
      },
      "shop": {
        "sellPrice": "verkauft für",
        "buyPrice": "kauft für"
      },
      "shopCommodity": {
        "item": "Gegenstand",
        "shop": "Geschäft",
        "buyPrices": "Kaufpreise",
        "rentalPrices": "Mietpreise",
        "confirmed": "Bestätigt?",
        "prices": {
          "label": "Preise",
          "sellPrice": "verkauft für",
          "buyPrice": "kauft für"
        }
      },
      "statsCard": {
        "stock": "Serie: %{value}",
        "more": "+%{count} weitere auf der Detailseite",
        "unavailable": "Diese Details konnten nicht geladen werden.",
        "loading": "%{name} wird geladen…",
        "offeredBy": "Angeboten von %{name}",
        "rsiHandle": "RSI-Handle %{handle}",
        "types": {
          "Component": "Komponente",
          "Equipment": "Ausrüstung",
          "Commodity": "Rohstoff",
          "Model": "Schiff",
          "Blueprint": "Bauplan",
          "GameMission": "Mission",
          "Location": "Ort",
          "FleetContract": "Auftrag",
          "FleetEvent": "Event",
          "User": "Benutzer",
          "FleetMember": "Mitglied"
        },
        "open": {
          "Component": "Komponente öffnen",
          "Equipment": "Ausrüstung öffnen",
          "Commodity": "Rohstoff öffnen",
          "Model": "Schiff öffnen",
          "Blueprint": "Bauplan öffnen",
          "GameMission": "Mission öffnen",
          "Location": "Ort öffnen",
          "FleetContract": "Auftrag öffnen",
          "FleetEvent": "Event öffnen",
          "User": "Hangar öffnen",
          "FleetMember": "In der Mitgliederliste zeigen"
        }
      },
      "stats": {
        "quickStats": {
          "newShips": "Neue Schiffe in %{year}",
          "totalShips": "Schiffe gesamt",
          "totalMembers": "Mitglieder gesamt",
          "vehicles": "Hangar Schiffe",
          "wishlists": "Wunschliste Schiffe",
          "shipOfTheMonth": "Schiff des Monats"
        },
        "modelsByClassification": "Ships by Classification",
        "modelsBySize": "Ships by Size",
        "vehiclesByModel": "Ships by Model (Top %{limit})",
        "modelsPerMonth": "Ships per Month",
        "modelsByManufacturer": "Ships by Manufacturer",
        "modelsByProductionStatus": "Ships by Production Status",
        "vehiclesPerMonth": "Hangar Schiffe pro Monat",
        "topVehiclesByModel": "Top 10 Hangar Schiffe",
        "shipsOfTheMonth": "Schiff des Monats",
        "trendingShips": "Meistgesehene Schiffe (30 Tage)",
        "wishlistByModel": "Meistgewünschte Schiffe",
        "wishToOwnRatio": "Gewünscht pro 100 im Hangar",
        "topPaints": "Beliebteste Lackierungen",
        "paintedVehicles": "Lackierte Schiffe",
        "pledgePriceChanges": "Pledge-Preisänderungen (12 Monate)",
        "ingamePriceChanges": "Ingame-Preisänderungen (30 Tage)",
        "mostWishlisted": "Meistgewünschte Schiffe diesen Monat",
        "patchChanges": "Am stärksten von diesem Patch verändert",
        "crewDeficit": "Crew Defizit",
        "crewSurplus": "Crew Überschuss",
        "membersByRole": "Mitglieder nach Rolle",
        "csv": {
          "metric": "Kennzahl",
          "value": "Wert",
          "count": "Anzahl"
        }
      },
      "roadmap": {
        "releases": "Veröffentlichungen",
        "released": "Veröffentlicht",
        "lastVersion": {
          "active": {
            "false": "Element wurde von der Roadmap entfernt",
            "true": "Element wurde wieder zur Roadmap hinzugefügt"
          },
          "released": "Item was released to PU",
          "release": "Item moved from release %{old} to %{new}"
        },
        "stories": {
          "one": "%{count} Story",
          "other": "%{count} Stories"
        },
        "tasks": {
          "one": "of %{count} Task",
          "other": "of %{count} Tasks"
        },
        "ships": {
          "one": "%{count} Ship",
          "other": "%{count} Ships"
        }
      },
      "unknown": "Unbekannt",
      "none": "-",
      "notAvailable": "N/A",
      "not-available": "N/A",
      "name": "Name",
      "homepage": "Homepage",
      "discord": "Discord-Server",
      "youtube": "Youtube-Kanal",
      "twitch": "Twitch-Kanal",
      "guilded": "Guilded-Server",
      "3dView": "3D",
      "3dMap": "Map",
      "texturedHolo": "Texturiert",
      "viewInAr": "AR",
      "viewInArHint": "In echter Größe in deinem Raum platzieren",
      "filter": "Filter",
      "taxExcluded": "zzgl. MwSt.",
      "hangar": "Hangar",
      "public": "Öffentlich",
      "hangarStats": "Statistiken",
      "wishlist": "Wunschliste",
      "fleetchart": "Flottenübersicht",
      "fleetchartScale": "Schiffsgröße",
      "fleetchartApp": {
        "screenHeight": "Bildschirmhöhe",
        "viewpoint": "Blickpunkt",
        "screenHeightOptions": {
          "auto": "Auto",
          "1x": "1x",
          "1_5x": "1.5x",
          "2x": "2x",
          "3x": "3x",
          "4x": "4x"
        },
        "viewpointOptions": {
          "port": "Backbord",
          "top": "Oben",
          "angled": "Schräg",
          "front": "Front"
        },
        "gridSize": "%{size} Meter pro Rasterfeld",
        "mode": "Modus",
        "modeOptions": {
          "classic": "Klassisch",
          "panzoom": "v2"
        }
      },
      "fleetStats": "Statistiken",
      "hangarMetrics": {
        "total": "Gesamt",
        "totalMoney": "Pledge-Wert",
        "totalCredits": "In-Game gekauft Wert",
        "totalIngameValue": "Hangar aUEC-Wert",
        "totalCrew": "Besatzung",
        "totalCargo": "Gesamtfracht",
        "largestShip": "Größtes Schiff",
        "smallestShip": "Kleinstes Schiff",
        "averagePledgePrice": "Ø Pledge-Preis",
        "flightReady": "Flugbereit",
        "uniqueModels": "Einzigartige Modelle",
        "manufacturerCount": "Hersteller",
        "missingClassifications": "Fehlende Rollen",
        "wishlistTotalMoney": "Wunschliste Pledge-Wert",
        "wishlistTotalCredits": "Wunschliste In-Game-Wert"
      },
      "selectModel": "Schiff auswählen",
      "findModel": "Tippen, um ein Schiff zu suchen",
      "find": "Suchbegriff eintippen",
      "selectUser": "Benutzer auswählen",
      "findUser": "Tippen, um einen Benutzer zu suchen",
      "selectAdminUser": "Admin Benutzer auswählen",
      "selectFleet": "Flotte auswählen",
      "findFleet": "Tippen, um eine Flotte zu suchen",
      "compare": {
        "removeModel": "Schiff entfernen",
        "addModel": {
          "nullablePrompt": "Schiff hinzufügen"
        },
        "enough": "Don't you think 8 Ships are enough? ;)",
        "shipCount": {
          "one": "%{count} Schiff",
          "other": "%{count} Schiffe"
        },
        "containersOfSize": "%{size} SCU Container",
        "armorHp": "Panzerungs-HP",
        "fuelAndQuantum": "Treibstoff & Quantum",
        "weaponPoolSize": "Waffen-Energiepool",
        "crossSection": {
          "x": "Querschnitt X",
          "y": "Querschnitt Y",
          "z": "Querschnitt Z"
        },
        "useAsBaseline": "Als Referenz verwenden",
        "baseline": "Referenz",
        "differencesOnly": "Nur Unterschiede",
        "compareToBaseline": "Mit Referenz vergleichen",
        "loadoutBySlot": "Loadout nach Slot",
        "slots": {
          "guns": "Hauptwaffen",
          "turrets": "Geschütztürme",
          "missiles": "Raketen",
          "shields": "Schildgeneratoren",
          "powerPlants": "Kraftwerke",
          "coolers": "Kühler",
          "quantumDrives": "Quantum-Antriebe",
          "thrusters": "Haupttriebwerke",
          "countermeasures": "Gegenmaßnahmen"
        },
        "legend": {
          "best": "bester Wert der Zeile",
          "worst": "schlechtester",
          "share": "Anteil am besten Wert der Zeile",
          "better": "besser als die Referenz",
          "worse": "schlechter"
        },
        "selectShips": "Schiffe auswählen"
      },
      "au": "AU",
      "uec": "aUEC",
      "sell": "Verkaufen",
      "buy": "Kaufen",
      "yourFlagship": "Ihr Flaggschiff",
      "flagship": "Flaggschiff",
      "fleet": {
        "headquarters": "Hauptquartier",
        "index": "Flotte",
        "destroyInfo": "If you want to delete this Fleet and remove all its information from Fleetyards.net click the button below. Be aware that this is a permanent action and can't be reverted.",
        "classes": "Flotte",
        "fid": "Flotten-ID",
        "name": "Name",
        "logo": "Logo",
        "rsiSid": "SID",
        "rsiSettings": {
          "hint": "Die Flotten-ID ist die Adresse deiner Flotte auf Fleetyards. Die SID verknüpft die Flotte mit ihrer RSI-Organisation, und die Verifizierung zeigt, dass die Organisation dir gehört."
        },
        "fidClaim": {
          "claimableTitle": "Flotten-ID %{fid} beanspruchen",
          "claimable": "Deine Flotte ist für die RSI-Organisation %{fid} verifiziert, aber eine andere Flotte hat die Flotten-ID %{fid}. Wenn du sie beanspruchst, hat diese Flotte 14 Tage Zeit, die Organisation selbst nachzuweisen oder ihre Mitglieder zu informieren. Danach wird sie umbenannt, und %{fid} wird die ID deiner Flotte.",
          "pendingTitle": "Anspruch auf %{fid} läuft",
          "pending": "%{holder} behält %{fid} bis %{date}. Danach geht die ID an deine Flotte, außer diese Flotte weist vorher nach, dass sie die Organisation %{fid} führt.",
          "availableTitle": "Die Flotten-ID %{fid} ist frei",
          "available": "Deine Flotte ist für %{fid} verifiziert, und keine andere Flotte nutzt diese ID. Trag sie oben als Flotten-ID ein.",
          "incomingTitle": "%{claimant} beansprucht eure Flotten-ID",
          "incoming": "%{claimant} ist für die RSI-Organisation **%{fid}** verifiziert.\n\n**Am %{date}:**\n\n- Deine Flotte bekommt die nächste freie Flotten-ID, etwa **%{fid}-1**.\n- Links auf %{fid} öffnen ab dann %{claimant}.\n\n**Um die ID zu behalten**, verifiziere %{fid} vorher. Andernfalls sag deinen Mitgliedern Bescheid, dass sich die Adresse ändert.",
          "createTakenTitle": "%{fid} ist vergeben",
          "createTaken": "Wenn %{fid} deine RSI-Organisation ist, starte mit %{suggestion} und der SID %{fid}. Sobald deine Flotte für %{fid} verifiziert ist, kann sie die Flotten-ID von der Flotte beanspruchen, die sie hat."
        },
        "rsiVerification": {
          "extension": {
            "title": "Mit der FleetYards-Sync-Erweiterung verifizieren",
            "verify": "Mit Erweiterung verifizieren",
            "description": "Die Erweiterung fügt deinen Code in die Geschichte deiner Organisation bei RSI ein, veröffentlicht sie, prüft die Seite und entfernt den Code danach wieder.",
            "detecting": "Suche nach der FleetYards-Sync-Erweiterung",
            "install": "Installiere die FleetYards-Sync-Erweiterung, um deine Flotte mit einem Klick zu verifizieren.",
            "update": "Aktualisiere die FleetYards-Sync-Erweiterung, um deine Flotte mit einem Klick zu verifizieren: Die installierte Version unterstützt das noch nicht.",
            "notSignedIn": "Melde dich in diesem Browser bei RSI mit einem Konto an, das %{sid} bearbeiten darf, oder verifiziere unten von Hand.",
            "noRights": "Das RSI-Konto, mit dem dieser Browser angemeldet ist, darf die Seite von %{sid} nicht bearbeiten. Melde dich mit einem Offizierskonto an oder verifiziere unten von Hand.",
            "pendingChanges": "%{sid} hat unveröffentlichte Änderungen bei RSI. Veröffentliche oder lösche diesen Entwurf zuerst, damit die Erweiterung keine fremde Änderung veröffentlicht, oder verifiziere unten von Hand.",
            "orgUnreadable": "Die Erweiterung konnte die Seite von %{sid} bei RSI nicht lesen. Verifiziere unten von Hand.",
            "failed": "Die Erweiterung konnte die Seite von %{sid} nicht ändern. Versuche es erneut oder verifiziere unten von Hand.",
            "removeFailed": "Die Erweiterung konnte den Code nicht aus der Geschichte von %{sid} entfernen. Entferne ihn dort von Hand.",
            "manual": "Oder von Hand verifizieren:"
          },
          "steps": {
            "copy": "Kopiere deinen Verifizierungscode",
            "paste": "Füge ihn irgendwo auf der öffentlichen RSI-Seite deiner Organisation ein: in der Einleitung, der Geschichte, dem Manifest oder der Charta. Sobald die Flotte verifiziert ist, kannst du ihn wieder entfernen.",
            "check": "Prüfe die Seite"
          },
          "openOrgPage": "%{sid} auf RSI öffnen",
          "fidAtRiskTitle": "Deine Flotten-ID ist nicht geschützt",
          "saveFirst": "Speichere die SID, bevor du sie verifizierst.",
          "title": "RSI-Verifizierung",
          "token": "Verifizierungscode",
          "verified": "Verifizierte RSI-Organisation",
          "unverified": "Nicht bei RSI verifiziert",
          "verifiedSince": "Verifiziert seit %{date}",
          "nextCheck": "Du kannst in einer Minute erneut prüfen.",
          "fidAtRisk": "Eine andere Flotte, die die RSI-Organisation %{fid} verifiziert, kann sie übernehmen, und die Adresse deiner Flotte ändert sich.",
          "statuses": {
            "pending": "Die Organisationsseite wird geprüft…",
            "token_missing": "Der Code steht noch nicht auf der Organisationsseite. RSI kann einige Minuten brauchen, bis eine Änderung sichtbar ist.",
            "symbol_mismatch": "Die Seite, die RSI geliefert hat, gehört zu einer anderen Organisation.",
            "not_found": "RSI kennt keine Organisation mit dieser SID.",
            "failed": "Die Organisationsseite konnte nicht geprüft werden. Versuche es in einer Minute erneut."
          }
        },
        "description": "Beschreibung",
        "public": "Öffentliche Flottenansicht",
        "publicFleet": "Öffentliche Flotte",
        "publicStats": "Öffentliche Statistiken",
        "publicFleetStats": "Öffentliche Flottenstatistiken",
        "discord": {
          "url": "Discord-Server",
          "hint": "Verbinde einen Discord-Server, um Events als native geplante Events zu spiegeln. Mitglieder können direkt in Discord zusagen, und die Anmeldung wird zurück zu Fleetyards synchronisiert.",
          "guildId": "Discord-Server-ID",
          "channelId": "Voice-Channel-ID (optional)",
          "webhookUrl": "Ankündigungs-Webhook-URL (optional)",
          "installBotHint": "Öffnet die Discord-Installationsseite in einem neuen Tab — wähle dort den Server, auf den Events gespiegelt werden sollen.",
          "announcementChannel": "Ankündigungskanal",
          "announcementChannelHint": "Neue Events und Erinnerungen kurz vor dem Start werden hier gepostet. Ohne Kanal laufen sie über den Webhook. Events, die auf Staffeln beschränkt sind, werden stattdessen in den Kanälen der Staffeln gepostet.",
          "officersChannel": "Offizierskanal",
          "officersChannelHint": "Events, die nur Offiziere sehen, werden hier angekündigt und nirgends sonst auf Discord. Ohne Kanal werden sie auf Discord gar nicht angekündigt. Auch Beitrittsanfragen werden hier gepostet, mit Buttons zum Annehmen oder Ablehnen.",
          "digestWeekday": "Wöchentliche Übersicht",
          "digestWeekdayHint": "Einmal pro Woche bekommt jeder Kanal eine Liste der Events der nächsten sieben Tage, die er sehen darf. Leer lassen, um sie abzuschalten.",
          "digestTime": "Uhrzeit der Übersicht",
          "digestTimeHint": "In deiner Zeitzone (%{timezone}).",
          "channelMissing": "Dieser Kanal existiert auf Discord nicht mehr oder nimmt keine Beiträge mehr an. Bis ein anderer gewählt ist, wird nichts gepostet.",
          "missingChannel": "Nicht verfügbarer Kanal",
          "joinRole": "Beitrittsrolle",
          "joinRoleHint": "Spieler mit dieser Rolle auf dem Server treten der Flotte ohne Anfrage bei, mit dem Standardrang. Wird ihnen die Rolle entzogen, verlassen die Mitglieder, die über sie beigetreten sind, die Flotte wieder. Leer lassen, um jede Anfrage von Hand zu bestätigen.",
          "roleMissing": "Diese Rolle gibt es auf Discord nicht mehr. Niemand tritt über sie bei, bis eine andere gewählt ist.",
          "missingRole": "Nicht verfügbare Rolle",
          "saveGuildFirst": "Speichere zuerst den neuen Server und wähle dann seine Kanäle und Rollen.",
          "roleMapping": "Discord-Rollen",
          "roleMappingHint": "Fleetyards vergibt diese Rollen im Server und nimmt sie wieder weg, wenn Mitglieder ihren Rang wechseln oder die Flotte verlassen. Es fügt nur die hier gewählten Rollen hinzu oder entfernt sie.",
          "memberRole": "Mitgliedsrolle",
          "memberRoleHint": "Jedes Mitglied der Flotte bekommt diese Rolle, unabhängig vom Rang.",
          "rolesCodes": {
            "missing_manage_roles": "Der Bot darf in diesem Server keine Rollen verwalten. Autorisiere ihn über den Installationslink neu.",
            "unknown_role": "Eine hier gewählte Rolle gibt es auf Discord nicht mehr: %{names}.",
            "role_above_bot": "Der Bot kann %{names} nicht vergeben: Discord erlaubt ihm nur Rollen unterhalb seiner eigenen. Verschiebe die Rolle des Bots in den Servereinstellungen darüber."
          },
          "postingCodes": {
            "missing_send_messages": "Der Bot darf auf diesem Server keine Nachrichten senden. Autorisiere ihn über den Installationslink neu.",
            "channel_locked": "Der Bot kann nicht im Kanal posten, der für %{names} gewählt ist. Erlaube es in den Berechtigungen des Kanals.",
            "unknown_channel": "Der für %{names} gewählte Kanal existiert auf Discord nicht mehr oder nimmt keine Beiträge mehr an.",
            "channel_shared": "%{names} teilt einen Kanal mit Lesern, vor denen ihre Events verborgen sind. Dort wird nichts gepostet, bis jede einen eigenen Kanal hat."
          },
          "joinRoleCodes": {
            "members_intent_missing": "Der Fleetyards-Bot darf die Mitglieder dieses Servers noch nicht auflisten, daher greift die Beitrittsrolle nur, wenn ein Spieler einen Einladungslink nutzt. Wende dich an einen Administrator.",
            "live_updates_off": "Rollenänderungen erreichen Fleetyards einmal am Tag: Der Bot hört nicht auf sie, während sie passieren. Wende dich an einen Administrator.",
            "bot_offline": "Der Fleetyards-Bot ist gerade nicht mit Discord verbunden, daher warten Rollenänderungen auf den täglichen Abgleich. Wende dich an einen Administrator."
          },
          "statusOk": "Verbunden mit %{name}",
          "statusCodes": {
            "missing_token": "Der Fleetyards-Bot ist serverseitig nicht konfiguriert. Wende dich an einen Administrator.",
            "missing_guild": "Gib zuerst eine Discord-Server-ID ein.",
            "invalid_token": "Das Bot-Token ist ungültig. Wende dich an einen Administrator.",
            "bot_not_in_guild": "Der Bot ist nicht auf diesem Server. Nutze den Installationslink, um ihn hinzuzufügen.",
            "guild_not_found": "Discord kennt diese Server-ID nicht. Überprüfe den Wert.",
            "discord_error": "Discord hat einen unerwarteten Fehler zurückgegeben.",
            "request_failed": "Fleetyards konnte nicht erreicht werden. Versuche es erneut."
          }
        },
        "guilded": "Guilded-Server",
        "homepage": "Homepage",
        "twitch": "Twitch-Kanal",
        "youtube": "Youtube-Kanal",
        "backgroundImage": "Hintergrundbild",
        "ts": "Teamspeak-Server",
        "awaitingConfirmation": "Wartet auf Bestätigung durch die Flotte",
        "members": {
          "verifiedOrgMember": "Verifiziertes Mitglied von %{sid}",
          "verifiedOrgMemberChecked": "Verifiziertes Mitglied von %{sid}, geprüft %{checked}",
          "primary": "Primäre Flotte?",
          "shipsFilter": {
            "label": "Welche Schiffe sollen zur Flotte hinzugefügt werden?",
            "nullablePrompt": "Keine Option ausgewählt",
            "field": "Schiffsauswahl",
            "values": {
              "all": "Alle Schiffe",
              "hangar_group": "Alle Schiffe in einer bestimmten Hangar-Gruppe",
              "hide": "Keine Schiffe"
            }
          },
          "hangarGroupId": {
            "field": "Hangar-Gruppe",
            "label": "Hangar-Gruppe angeben",
            "nullablePrompt": "Keine Gruppe ausgewählt"
          },
          "blueprintsFilter": {
            "label": "Welche Baupläne sollen mit der Flotte geteilt werden?",
            "nullablePrompt": "Keine Option ausgewählt",
            "field": "Baupläne-Auswahl",
            "values": {
              "all": "Alle Baupläne, die ich besitze",
              "hide": "Keine Baupläne"
            }
          },
          "total": "Gesamt: %{count}",
          "rsiTotal": "Auf RSI: %{count}",
          "joined": "Beigetreten am",
          "invited": "Eingeladen",
          "invitedAt": "Eingeladen / Angefragt am",
          "requested": "Mitgliedschaft angefragt",
          "declined": "Abgelehnt",
          "pending": "Ausstehende Einladungen & Anfragen",
          "accepted": "Mitglieder",
          "role": "Rolle",
          "contact": "Kontakt",
          "spectrumDm": "Nachricht auf Spectrum",
          "discordContact": "Discord",
          "views": {
            "members": "Mitglieder",
            "invites": "Einladungen"
          },
          "health": {
            "overview": "Prüfungen",
            "summary": {
              "attention": {
                "one": "%{count} von %{total} Prüfungen braucht Aufmerksamkeit",
                "other": "%{count} von %{total} Prüfungen brauchen Aufmerksamkeit"
              },
              "clear": "Alle %{total} Prüfungen sind in Ordnung"
            },
            "groups": {
              "leadership": "Führung",
              "rsi": "RSI-Organisation",
              "activity": "Aktivität",
              "requests": "Anfragen und Einladungen",
              "integrations": "Integrationen"
            },
            "days": {
              "one": "%{count} Tag",
              "other": "%{count} Tage"
            },
            "checks": {
              "admins": {
                "title": "Admins",
                "overview": "Admins",
                "clear": "%{admins} Mitglieder sind Admin."
              },
              "unverified": {
                "title": "Nicht gegen %{sid} verifiziert",
                "overview": "Nicht verifiziert",
                "description": "Ein Mitglied ist verifiziert, wenn seine eigene Liste der RSI-Organisationen %{sid} enthält. Jede Zeile sagt, warum das nicht bestätigt werden konnte.",
                "clear": "Alle Mitglieder sind gegen %{sid} verifiziert."
              },
              "noHandle": {
                "title": "Kein RSI-Handle",
                "overview": "Kein RSI-Handle",
                "clear": "Alle Mitglieder haben ein RSI-Handle angegeben."
              },
              "inactive": {
                "title": "Inaktive Mitglieder",
                "overview": "Inaktiv seit %{count}+ Tagen",
                "clear": "Alle waren in den letzten %{count} Tagen aktiv."
              },
              "joinRequests": {
                "title": "Beitrittsanfragen, die über eine Woche warten",
                "overview": "Alte Beitrittsanfragen",
                "clear": "Keine Beitrittsanfrage wartet länger als eine Woche."
              },
              "invitations": {
                "title": "Unbeantwortete Einladungen",
                "overview": "Offene Einladungen",
                "clear": "Keine Einladung ist länger als zwei Wochen offen."
              },
              "inviteUrls": {
                "title": "Einladungslinks zum Aufräumen",
                "overview": "Einladungslinks",
                "clear": "Alle Einladungslinks werden genutzt."
              },
              "discord": {
                "title": "Nicht mit Discord verknüpft",
                "overview": "Discord",
                "clear": "Alle Mitglieder haben Discord verknüpft."
              },
              "emptySquadrons": {
                "title": "Staffeln ohne Mitglieder",
                "overview": "Leere Staffeln",
                "clear": "Jede Staffel hat Mitglieder."
              },
              "noSquadron": {
                "title": "Mitglieder ohne Staffel",
                "overview": "Ohne Staffel",
                "clear": "Alle Mitglieder sind in einer Staffel."
              },
              "hiddenShips": {
                "title": "Schiffe außerhalb der Flotte",
                "overview": "Verborgene Hangars",
                "clear": "Alle Mitglieder teilen ihre Schiffe mit der Flotte."
              }
            },
            "facts": {
              "joined": "Beigetreten am %{date}",
              "lastActive": "Zuletzt aktiv %{distance}",
              "neverActive": "Nie aktiv",
              "checked": "Geprüft %{distance}",
              "requested": "Angefragt %{distance}",
              "invited": "Eingeladen %{distance}",
              "invitedBy": "Eingeladen von %{name}",
              "noDiscord": "Kein Discord-Konto verknüpft",
              "noSquadron": "Keine Staffel",
              "noHandle": "Kein Handle angegeben",
              "linkExpired": "Abgelaufen %{distance}",
              "linkUsedUp": "Keine Nutzungen übrig",
              "createdBy": "Erstellt von %{name}",
              "used": {
                "one": "Einmal genutzt",
                "other": "%{count}-mal genutzt"
              },
              "team": "Team",
              "created": "Erstellt am %{date}",
              "linkUnused": "Nie genutzt, erstellt %{distance}"
            },
            "gaps": {
              "no_handle": "Kein RSI-Handle im Profil",
              "handle_unverified": "RSI-Handle nicht verifiziert",
              "orgs_not_checked": "Organisationsliste noch nicht gelesen",
              "org_not_listed": "%{sid} nicht in ihrer Organisationsliste"
            },
            "orgStats": {
              "rsi": "%{sid} auf RSI",
              "roster": "Auf FleetYards",
              "gap": "Hier nie beigetreten"
            },
            "fleetNotVerified": "%{sid} selbst ist noch nicht verifiziert, deshalb wird an anderer Stelle kein Mitglied als verifiziert angezeigt.",
            "singleAdmin": "Wenn %{name} die Flotte verlässt oder den Zugang verliert, kann niemand %{fleet} auf FleetYards verwalten.",
            "hiddenShips": {
              "one": "%{count} Mitglied hält seinen Hangar aus der Schiffsliste der Flotte heraus.",
              "other": "%{count} Mitglieder halten ihren Hangar aus der Schiffsliste der Flotte heraus."
            },
            "deleteLinkFailed": "Der Einladungslink konnte nicht gelöscht werden.",
            "noAdmin": "Niemand ist Admin, deshalb kann niemand %{fleet} auf FleetYards verwalten.",
            "adminCandidates": "Zum Admin befördern",
            "addedToSquadron": {
              "success": "Zur Staffel hinzugefügt.",
              "failure": "Konnte nicht zur Staffel hinzugefügt werden."
            },
            "reminded": {
              "success": "Erinnerung gesendet.",
              "failure": "Die Erinnerung konnte nicht gesendet werden."
            },
            "remindedAt": "Erinnert %{distance}. Eine Woche danach kannst du erneut erinnern."
          },
          "card": {
            "verified": "Verifiziert",
            "unverified": "Nicht verifiziert",
            "squadrons": "Staffeln"
          }
        },
        "squadrons": {
          "index": "Staffeln",
          "name": "Name",
          "shortDescription": "Kurzbeschreibung",
          "shortDescriptionHint": "Ein, zwei Zeilen auf der Karte",
          "description": "Beschreibung",
          "descriptionHint": "Der vollständige Text auf der Staffelseite",
          "noDescription": "Es wurde noch keine Beschreibung hinzugefügt.",
          "icon": "Symbol",
          "iconHint": "Quadratisches Bild, wird rund angezeigt",
          "team": "Team",
          "teamHint": "Teams stehen allen offen – sonst gehört ein Mitglied nur einer Staffel an",
          "restrictedToHint": "Nur diese Staffeln sehen es",
          "discordChannel": "Discord-Kanal",
          "discordChannelHint": "Events, die auf diese Staffel beschränkt sind, werden hier angekündigt und nirgends sonst auf Discord. Ohne Kanal werden sie auf Discord gar nicht angekündigt.",
          "notAnnounced": "Für %{names} wird nicht auf Discord angekündigt: Es ist kein Discord-Kanal eingerichtet.",
          "blockedBy": "Bereits in der Staffel %{squadron}",
          "color": "Farbe",
          "colorSuggestions": "Aus dem Symbol:",
          "memberCount": "%{count} Mitglieder",
          "members": "Mitglieder",
          "joinedAt": "Beitritt zum Geschwader",
          "searchMembers": "Mitglieder suchen",
          "availableMembers": "verfügbare Mitglieder",
          "selectedMembers": "%{count} ausgewählt",
          "rank": "Rang",
          "ranksHint": "Die Namen, die jede Staffel dieser Flotte verwendet. Ein umbenannter Rang behält seinen Platz und seine Rechte.",
          "rankName": "Name",
          "defaultRank": "Standard",
          "defaultRankToggle": "Neue Mitglieder beginnen mit diesem Rang",
          "rankRights": {
            "singleHolder": "Einer pro Staffel",
            "managesMembers": "Fügt Mitglieder mit niedrigerem Rang hinzu und entfernt sie",
            "managesRanks": "Legt die Ränge unter dem eigenen fest"
          },
          "views": {
            "members": "Mitglieder",
            "requests": "Anfragen"
          },
          "requestedAt": "Angefragt am",
          "requests": "Anfragen"
        },
        "roles": {
          "permanent": "Permanent",
          "default": "Standard",
          "defaultToggle": "Neue Mitglieder erhalten diese Rolle",
          "privilegeGroups": {
            "fleet": "Flotte",
            "memberships": "Mitglieder",
            "squadrons": "Staffeln",
            "invites": "Einladungen",
            "vehicles": "Fahrzeuge",
            "blueprints": "Baupläne",
            "roles": "Rollen",
            "inventories": "Inventare",
            "missions": "Missionen",
            "events": "Events",
            "allies": "Verbündete",
            "contracts": "Aufträge",
            "payouts": "Auszahlungen",
            "notifications": "Benachrichtigungen",
            "announcements": "Ankündigungen"
          },
          "privileges": {
            "fleet:update": "Flotte bearbeiten",
            "fleet:update:images": "Bilder bearbeiten",
            "fleet:update:description": "Beschreibung bearbeiten",
            "fleet:delete": "Flotte löschen",
            "fleet:manage": "Flotte verwalten",
            "fleet:memberships:read": "Mitglieder ansehen",
            "fleet:memberships:create": "Mitglieder einladen",
            "fleet:memberships:update": "Mitglieder bearbeiten",
            "fleet:memberships:delete": "Mitglieder entfernen",
            "fleet:memberships:manage": "Mitglieder verwalten",
            "fleet:squadrons:read": "Staffeln ansehen",
            "fleet:squadrons:create": "Staffeln anlegen",
            "fleet:squadrons:update": "Staffeln bearbeiten",
            "fleet:squadrons:delete": "Staffeln löschen",
            "fleet:squadrons:members:manage": "Staffelmitglieder verwalten",
            "fleet:squadrons:manage": "Staffeln verwalten",
            "fleet:invites:read": "Einladungen ansehen",
            "fleet:invites:create": "Einladungen erstellen",
            "fleet:invites:update": "Einladungen bearbeiten",
            "fleet:invites:delete": "Einladungen löschen",
            "fleet:invites:manage": "Einladungen verwalten",
            "fleet:vehicles:read": "Fahrzeuge ansehen",
            "fleet:vehicles:create": "Fahrzeuge hinzufügen",
            "fleet:vehicles:update": "Fahrzeuge bearbeiten",
            "fleet:vehicles:delete": "Fahrzeuge entfernen",
            "fleet:vehicles:manage": "Fahrzeuge verwalten",
            "fleet:blueprints:read": "Baupläne ansehen",
            "fleet:roles:read": "Rollen ansehen",
            "fleet:roles:create": "Rollen erstellen",
            "fleet:roles:update": "Rollen bearbeiten",
            "fleet:roles:delete": "Rollen löschen",
            "fleet:roles:manage": "Rollen verwalten",
            "fleet:inventories:read": "Inventare anzeigen",
            "fleet:inventories:create": "Inventare erstellen",
            "fleet:inventories:update": "Inventare aktualisieren",
            "fleet:inventories:delete": "Inventare löschen",
            "fleet:inventories:manage": "Inventare verwalten",
            "fleet:missions:read": "Missionen anzeigen",
            "fleet:missions:create": "Missionen erstellen",
            "fleet:missions:update": "Missionen aktualisieren",
            "fleet:missions:delete": "Missionen löschen",
            "fleet:missions:manage": "Missionen verwalten",
            "fleet:events:read": "Events anzeigen",
            "fleet:events:create": "Events erstellen",
            "fleet:events:update": "Events aktualisieren",
            "fleet:events:delete": "Events löschen",
            "fleet:events:manage": "Events verwalten",
            "fleet:allies:read": "Verbündete anzeigen",
            "fleet:allies:create": "Verbündete hinzufügen",
            "fleet:allies:delete": "Verbündete entfernen",
            "fleet:allies:manage": "Verbündete verwalten",
            "fleet:contracts:read": "Aufträge anzeigen",
            "fleet:contracts:create": "Aufträge erstellen",
            "fleet:contracts:update": "Aufträge aktualisieren",
            "fleet:contracts:delete": "Aufträge löschen",
            "fleet:contracts:manage": "Aufträge verwalten",
            "fleet:payouts:read": "Auszahlungen anzeigen",
            "fleet:payouts:create": "Auszahlungen erfassen",
            "fleet:payouts:update": "Auszahlungen aktualisieren",
            "fleet:payouts:delete": "Auszahlungen löschen",
            "fleet:payouts:manage": "Auszahlungen verwalten",
            "fleet:notifications:manage": "Benachrichtigungseinstellungen verwalten",
            "fleet:announcements:manage": "Ankündigungen verwalten"
          },
          "name": "Name",
          "rank": "Rang"
        },
        "inviteUrls": {
          "noExpiration": "Läuft nie ab",
          "used": "%{count} mal verwendet",
          "usedOfLimit": "%{count} von %{limit} verwendet",
          "expiresIn": "Läuft ab in %{time}",
          "expired": "Abgelaufen",
          "expiresAfterOptions": {
            "infinite": "Never",
            "30_minutes": "30 minutes",
            "1_hour": "1 hour",
            "6_hours": "6 hours",
            "12_hours": "12 hours",
            "1_day": "1 Tag",
            "7_days": "7 days"
          },
          "limitOptions": {
            "1": "1 use",
            "5": "5 uses",
            "10": "10 uses",
            "25": "25 uses",
            "50": "50 uses",
            "100": "100 uses",
            "infinite": "No limit"
          }
        },
        "calendarSubscription": {
          "intro": "Erzeuge einen privaten Link, mit dem Mitglieder die Events dieser Flotte in ihrer Kalender-App abonnieren können (Apple Kalender, Google Kalender, Outlook).",
          "howTo": "Teile den Link oben mit deinen Mitgliedern. Sie fügen ihn in ihrer Kalender-App ein („Kalender abonnieren“ oder „Per URL hinzufügen“). Der Link ist privat — wer ihn hat, kann die Events dieser Flotte sehen."
        },
        "notifications": {
          "inAppHint": "Lege fest, welche Änderungen im Event-Ablauf als In-App-Benachrichtigungen für Flottenmitglieder erscheinen.",
          "events": {
            "fleet_event": {
              "published": "Event veröffentlicht",
              "locked": "Anmeldungen gesperrt",
              "unlocked": "Anmeldungen wieder freigegeben",
              "starting_soon": "Event beginnt bald",
              "started": "Event gestartet",
              "completed": "Event abgeschlossen",
              "cancelled": "Event abgesagt",
              "archived": "Event archiviert",
              "destroyed": "Event gelöscht"
            },
            "fleet_event_signup": {
              "created": "Anmeldung hinzugefügt",
              "withdrawn": "Anmeldung zurückgezogen"
            }
          }
        },
        "inventories": {
          "name": "Name",
          "description": "Beschreibung",
          "location": "Ort",
          "visibility": "Sichtbarkeit",
          "manager": "Verwalter",
          "itemsCount": "Einträge",
          "visibilities": {
            "members_only": "Nur Mitglieder",
            "officers_only": "Nur Offiziere",
            "squadron_only": "Nur eine Staffel"
          }
        },
        "allies": "Schiffe für Verbündete sichtbar",
        "alliesStats": "Statistiken für Verbündete sichtbar",
        "alliesMembers": "Mitgliederliste für Verbündete sichtbar",
        "squadronsEnabled": "Staffeln verwenden",
        "listed": "Im Flottenverzeichnis anzeigen",
        "listedInfo": "Eine verifizierte, öffentliche Flotte mit mindestens zwei Mitgliedern ist im Flottenverzeichnis zu finden. Eine private Flotte wird nie gelistet.",
        "alignment": "Ausrichtung",
        "alignments": {
          "lawful": "Legal",
          "neutral": "Neutral",
          "outlaw": "Gesetzlos"
        },
        "activities": {
          "bounty_hunting": "Kopfgeldjagd",
          "engineering": "Technik",
          "exploration": "Erkundung",
          "freelancing": "Freiberuflich",
          "infiltration": "Infiltration",
          "medical": "Medizin",
          "piracy": "Piraterie",
          "resources": "Rohstoffe",
          "scouting": "Aufklärung",
          "security": "Sicherheit",
          "smuggling": "Schmuggel",
          "social": "Soziales",
          "trading": "Handel",
          "transport": "Transport"
        },
        "commitments": {
          "casual": "Gelegentlich",
          "regular": "Regelmäßig",
          "hardcore": "Hardcore"
        },
        "rsiProfile": {
          "info": "Einmal täglich von der RSI-Seite deiner Organisation übernommen. Ändere diese Angaben auf RSI.",
          "primaryActivity": "Hauptaktivität",
          "secondaryActivity": "Nebenaktivität",
          "language": "Sprache",
          "commitment": "Engagement",
          "recruiting": "Rekrutiert",
          "roleplay": "Rollenspiel"
        },
        "contractCovers": {
          "transport": "Transport-Titelbild",
          "procurement": "Beschaffungs-Titelbild",
          "crafting": "Herstellungs-Titelbild"
        }
      },
      "hangarGroup": {
        "name": "Name",
        "color": "Farbe",
        "sort": "Sortierreihenfolge",
        "public": "Im öffentlichen Hangar anzeigen?"
      },
      "source": "Quelle",
      "loadout": {
        "marker": "Loadout „%{name}“",
        "fleetyards": "Fleetyards-Loadout",
        "namePlaceholder": "Loadout-Name...",
        "urlPlaceholder": "Loadout-URL von erkul.games oder spviewer.eu einfügen...",
        "activateHint": "Klicken, um dies zum aktiven Loadout zu machen",
        "activeHint": "Dies ist das aktive Loadout",
        "kinds": {
          "fleetyards": "Fleetyards",
          "erkul": "Erkul",
          "spviewer": "SPViewer",
          "link": "Link"
        },
        "public": "Öffentlich",
        "private": "Privat",
        "empty": "Noch keine Loadouts. Erstelle eines, um loszulegen.",
        "active": "Aktiv",
        "activate": "Als aktiv setzen"
      },
      "model": {
        "hidden": "Versteckt?",
        "active": "Aktiv?",
        "inGame": "Im Spiel?",
        "adiMap": "ADI Map?",
        "ground": "Bodenfahrzeug?",
        "productionNote": "Produktionshinweis",
        "rsiId": "RSI ID",
        "length": "Länge",
        "beam": "Breite",
        "height": "Höhe",
        "scKey": "SC-Key",
        "price": "Preis",
        "pledgePrice": "Pledge-Preis",
        "erkulIdentifier": "Erkul Identifier",
        "mass": "Masse",
        "crew": "Besatzung",
        "storeUrl": "Store URL",
        "salesPageUrl": "Sales Page URL",
        "scmSpeed": "SCM Speed",
        "scmSpeedBoosted": "SCM Speed Boosted",
        "maxSpeed": "Max. Geschwindigkeit",
        "reverseSpeedBoosted": "Reverse Speed Boosted",
        "cargo": "Fracht",
        "cargoHolds": "Frachträume",
        "keepCargo": "Diesen Frachtwert statt der Frachträume aus den Spieldateien behalten",
        "hydrogenFuelTankSize": "Hydrogen-Tankgröße",
        "hydrogenFuelTanks": "Hydrogen-Treibstofftanks",
        "quantumFuelTankSize": "Quantum-Tankgröße",
        "quantumFuelTanks": "Quantum-Treibstofftanks",
        "externalFuelTanks": "Externe Treibstofftanks",
        "orePods": "Erzbehälter",
        "weaponRacks": "Waffenständer",
        "medicalBedsTier": "Medizinische Betten Stufe %{tier}",
        "medicalBedsNamed": "Medizinische Betten (%{name})",
        "respawnBeds": "Respawn-Betten",
        "salvageStorage": "Bergungsspeicher",
        "externalFuelTanksTotal": "Gesamtkapazität",
        "externalFuelTanksCount": "Pods",
        "refuelBoom": "Betankungsausleger",
        "refuelBoomArm": "Arm",
        "refuelBoomNozzle": "Düse",
        "yaw": "Yaw",
        "pitch": "Pitch",
        "roll": "Roll",
        "yawBoosted": "Gieren verstärkt",
        "pitchBoosted": "Neigung verstärkt",
        "rollBoosted": "Rollen verstärkt",
        "variants": "Varianten",
        "manufacturer": "Hersteller",
        "loaners": "Leihschiffe",
        "paints": "Lackierungen",
        "modules": "Module",
        "modulePackages": "Modulpakete",
        "upgrades": "Upgrade-Kits",
        "brochure": "Broschüre",
        "holo": "Holo",
        "angledView": "Schrägansicht",
        "angledViewColored": "Schrägansicht Farbig",
        "portView": "Backbordansicht",
        "portViewColored": "Backbordansicht Farbig",
        "frontView": "Frontansicht",
        "frontViewColored": "Frontansicht Farbig",
        "topView": "Draufsicht",
        "topViewColored": "Draufsicht Farbig",
        "onSale": "Im Angebot",
        "playerOwnable": "Für Spieler erwerbbar?",
        "ingameOnly": "Nur im Spiel",
        "canLandOnPlanets": "Kann auf Planeten landen",
        "cannotLandOnPlanets": "Kann nicht auf Planeten landen",
        "salesPage": "Verkaufsseite",
        "addons": "Module & Upgrade-Kits",
        "storeImage": "Shop-Bild",
        "wiki": "Star Citizen Wiki",
        "crewPositions": "Besatzungspositionen",
        "needsCuration": "Kuratierung erforderlich",
        "curatedPosition": "Manuell kuratierte Position",
        "baseModel": "Basismodell",
        "fleetchartOffsetLength": "Flottenübersicht Versatz Länge",
        "fleetchartOffsetBeam": "Flottenübersicht Versatz Breite",
        "extendedLength": "Ausgefahrene Länge",
        "extendedBeam": "Ausgefahrene Breite",
        "extendedHeight": "Ausgefahrene Höhe",
        "extendedFleetchartOffsetLength": "Ausgefahrener Flottenkarten-Versatz Länge",
        "extendedFleetchartOffsetBeam": "Ausgefahrener Flottenkarten-Versatz Breite",
        "defaultHolo": "Standard-Holo",
        "extendedHolo": "Ausgefahrenes Holo",
        "extendedTopView": "Ausgefahrene Draufsicht",
        "extendedTopViewColored": "Ausgefahrene Draufsicht Farbig",
        "extendedPortView": "Ausgefahrene Backbordansicht",
        "extendedPortViewColored": "Ausgefahrene Backbordansicht Farbig",
        "extendedFrontView": "Ausgefahrene Frontansicht",
        "extendedFrontViewColored": "Ausgefahrene Frontansicht Farbig",
        "extendedAngledView": "Ausgefahrene Schrägansicht",
        "extendedAngledViewColored": "Ausgefahrene Schrägansicht Farbig",
        "landedHolo": "Gelandetes Holo",
        "landedTopView": "Gelandete Draufsicht",
        "landedPortView": "Gelandete Backbordansicht",
        "landedFrontView": "Gelandete Frontansicht",
        "landedAngledView": "Gelandete Schrägansicht",
        "landedTopViewColored": "Gelandete Draufsicht Farbig",
        "landedPortViewColored": "Gelandete Backbordansicht Farbig",
        "landedFrontViewColored": "Gelandete Frontansicht Farbig",
        "landedAngledViewColored": "Gelandete Schrägansicht Farbig",
        "angledRearView": "Schrägansicht hinten",
        "angledRearViewColored": "Schrägansicht hinten Farbig",
        "bottomView": "Unteransicht",
        "bottomViewColored": "Unteransicht Farbig",
        "rearView": "Rückansicht",
        "rearViewColored": "Rückansicht Farbig",
        "starboardView": "Steuerbordansicht",
        "starboardViewColored": "Steuerbordansicht Farbig",
        "extendedAngledRearView": "Ausgefahrene Schrägansicht hinten",
        "extendedAngledRearViewColored": "Ausgefahrene Schrägansicht hinten Farbig",
        "extendedBottomView": "Ausgefahrene Unteransicht",
        "extendedBottomViewColored": "Ausgefahrene Unteransicht Farbig",
        "extendedRearView": "Ausgefahrene Rückansicht",
        "extendedRearViewColored": "Ausgefahrene Rückansicht Farbig",
        "extendedStarboardView": "Ausgefahrene Steuerbordansicht",
        "extendedStarboardViewColored": "Ausgefahrene Steuerbordansicht Farbig",
        "landedAngledRearView": "Gelandete Schrägansicht hinten",
        "landedAngledRearViewColored": "Gelandete Schrägansicht hinten Farbig",
        "landedBottomView": "Gelandete Unteransicht",
        "landedBottomViewColored": "Gelandete Unteransicht Farbig",
        "landedRearView": "Gelandete Rückansicht",
        "landedRearViewColored": "Gelandete Rückansicht Farbig",
        "landedStarboardView": "Gelandete Steuerbordansicht",
        "landedStarboardViewColored": "Gelandete Steuerbordansicht Farbig",
        "holoLite": "Lite-Holo",
        "extendedHoloLite": "Ausgefahrenes Lite-Holo",
        "landedHoloLite": "Gelandetes Lite-Holo",
        "holoTextured": "Texturiertes Holo",
        "state": {
          "flight": "Im Flug",
          "extended": "Ausgefahren",
          "landed": "Gelandet"
        },
        "productionStatus": {
          "in-production": "In Produktion",
          "in-concept": "Im Konzept",
          "ready": "Hangar-bereit",
          "flight-ready": "Flugbereit",
          "announced": "Angekündigt"
        },
        "carriedBy": "Wird getragen von",
        "landedLength": "Länge gelandet",
        "landedBeam": "Breite gelandet",
        "landedHeight": "Höhe gelandet",
        "landedFleetchartOffsetLength": "Flottenübersicht-Versatz Länge gelandet",
        "landedFleetchartOffsetBeam": "Flottenübersicht-Versatz Breite gelandet",
        "owners": {
          "title": "In deinem Umfeld",
          "yourShips": "Deine Schiffe",
          "friends": "Freunde",
          "fleets": "Deine Flotten",
          "more": "+%{count} weitere",
          "empty": "Noch niemand, den du kennst, hat eins.",
          "fleetShips": {
            "one": "%{count} Schiff",
            "other": "%{count} Schiffe"
          }
        }
      },
      "models": {
        "extraColumns": "Spalten",
        "table": {
          "columns": {
            "storeImage": "Bild",
            "storeImageWide": "Breites Bild",
            "rsiStoreImage": "RSI-Bild",
            "rsiStoreImageWide": "Breites RSI-Bild",
            "angledView": "3D-Bild",
            "angledViewWide": "Breites 3D-Bild",
            "rsiId": "RSI ID",
            "hidden": "Versteckt",
            "active": "Aktiv",
            "createdAt": "Erstellt am",
            "updatedAt": "Aktualisiert am",
            "manufacturerName": "Hersteller",
            "length": "Länge",
            "beam": "Breite",
            "height": "Höhe",
            "mass": "Masse",
            "cargo": "Fracht",
            "quantumFuelTankSize": "Quantum-Treibstoff",
            "hydrogenFuelTankSize": "Hydrogen-Treibstoff",
            "crew": "Besatzung",
            "scmSpeed": "SCM Speed",
            "maxSpeed": "Max. Geschwindigkeit",
            "groundMaxSpeed": "Bodengeschwindigkeit",
            "focus": "Fokus",
            "productionStatus": "Produktionsstatus",
            "price": "Preis",
            "pledgePrice": "Pledge-Preis"
          }
        }
      },
      "metrics": {
        "info": "Info",
        "levels": "Ebenen",
        "views": "Ansichten",
        "base": "Basis",
        "crew": "Besatzung",
        "speed": "Geschwindigkeit",
        "cargo": "Fracht",
        "combat": "Kampf",
        "hardpoints": "Aufhängungspunkte"
      },
      "flight": {
        "boostCapacitor": "Boost-Kondensator",
        "boostCapacity": "Kapazität",
        "boostRegen": "Regeneration",
        "boostRegenDelay": "Regenerationsverzögerung",
        "boostRamp": "Anlauf / Auslauf",
        "title": "Flug",
        "scm": "Kampfgeschwindigkeit",
        "nav": "Reisegeschwindigkeit",
        "boost": "Boost",
        "boostSub": "Nachbrenner",
        "reverse": "Rückwärts",
        "maneuverability": "Manövrierfähigkeit",
        "fuel": "Treibstoff",
        "fuelHydrogen": "Hydrogen",
        "fuelQuantum": "Quantum",
        "fuelBurnMain": "Brenndauer, Haupt",
        "fuelBurnAll": "Brenndauer, alle",
        "fuelDrawMain": "Verbrauch, Haupt",
        "fuelDrawAll": "Verbrauch, alle",
        "durationHoursMinutes": "%{hours} h %{minutes} min",
        "durationMinutes": "%{minutes} min"
      },
      "base": {
        "price": "Preis",
        "priceInGame": "Im Spiel",
        "pricePledge": "Pledge",
        "availability": "Verfügbarkeit"
      },
      "availability": {
        "title": "Verfügbarkeit",
        "buy": "Kaufen",
        "rent": "Mieten",
        "sell": "Verkaufen",
        "cheapest": {
          "buy": "Günstigster Kauf",
          "rent": "Günstigste Miete"
        },
        "bestSale": "Bester Verkaufspreis",
        "allLocations": "Alle Standorte",
        "locations": {
          "one": "%{count} Standort",
          "other": "%{count} Standorte"
        },
        "empty": "Keine bekannten Kauf- oder Mietstandorte.",
        "timeRange": {
          "1-day": "1 Tag",
          "3-days": "3 Tage",
          "7-days": "7 Tage",
          "30-days": "30 Tage"
        }
      },
      "cargo": {
        "title": "Fracht",
        "holdsSub": "in %{count} Frachträumen",
        "maxContainerSub": "größte passende Box",
        "containers": "Containerkapazität"
      },
      "weaponRacks": {
        "slots": "Plätze",
        "racks": "Ständer",
        "categories": {
          "weapon": "Waffe",
          "gadget": "Gadget",
          "cargo": "Fracht",
          "carriable": "Tragbares",
          "armor": "Rüstung",
          "other": "Sonstiges"
        },
        "size": "S%{size}",
        "sizeRange": "S%{min}–S%{max}",
        "sizeUpTo": "bis S%{size}",
        "only": "nur %{tag}",
        "tags": {
          "multitool": "Multi-Tool",
          "medical_injection": "Medi-Pens",
          "grenade": "Granaten"
        }
      },
      "storageContainers": {
        "total": "Gesamtkapazität",
        "count": "Behälter",
        "perContainer": "je"
      },
      "fuelTanks": {
        "capacitySub": "in %{count} Pods",
        "podsSub": "externe Aufhängungen",
        "components": "Pod-Typen",
        "perPod": "pro Pod"
      },
      "refuelBoom": {
        "fuelFlowSub": "Hydrogen-Transfer",
        "quantumFlowSub": "Quantum-Transfer",
        "captureRadiusSub": "Andocktoleranz",
        "equipment": "Ausrüstung"
      },
      "combat": {
        "title": "Kampf",
        "openPenetrationCheck": "Durchschlagsprüfung",
        "dps": "Burst DPS",
        "dpsSub": "%{count} Waffen",
        "sustained": "Anhaltend",
        "sustainedSub": "mit Regen & Hitze",
        "alpha": "Alpha",
        "alphaSub": "pro Salve",
        "weapons": "Waffen",
        "missileDamage": "Raketenschaden",
        "armedMissiles": "Scharfe Raketen",
        "armedMissilesSub": "%{cooldown} s zwischen Starts",
        "composition": "Schadensverteilung",
        "damagePhysical": "Physisch",
        "damageEnergy": "Energie",
        "damageDistortion": "Distortion",
        "damageThermal": "Thermisch",
        "controlComposition": "DPS nach Steuerung",
        "controlGroups": {
          "pilot": "Pilot",
          "manned": "Bemannter Geschützturm",
          "remote": "Ferngesteuerter Geschützturm",
          "pds": "Punktverteidigung"
        }
      },
      "power": {
        "planner": {
          "sustained": "%{dps} Dauer-DPS",
          "weaponPower": "Waffenenergie %{percent}",
          "weaponsOff": "Waffen offline",
          "regen": "%{regen} HP/s Regeneration",
          "shieldsDown": "Schilde aus",
          "engineOff": "Triebwerk ohne Energie",
          "engineOffSub": "überhaupt kein Flug",
          "boostedHandling": "Geboostetes Handling %{percent}",
          "engineBase": "Nur Grundschub",
          "engineBaseSub": "Boost braucht mehr Segmente",
          "radarOff": "Radar dunkel",
          "coolant": "%{rate} Kühlmittel pro Sekunde",
          "noCooling": "Keine Kühlung",
          "ready": "Bereit zum Spool-Up",
          "off": "Aus",
          "needsBlock": "braucht seinen Block von %{min} zum Start",
          "powered": "Mit Energie",
          "segments": "Belegte Segmente",
          "signatures": "Signaturen",
          "plantSegments": "%{segments} Segmente",
          "segmentsTotal": "Segmente",
          "setPips": "%{name}: %{count} Segmente",
          "weaponEnergy": "Waffenenergie",
          "energyGun": "Energie · feuert aus ihrem Kondensator",
          "heatGun": "Ballistisch · durch Hitze begrenzt",
          "sustainedEach": "Dauer-DPS je",
          "capacitor": "Kondensator",
          "shots": "%{count} von %{max} Schuss",
          "firing": "Zeit am Abzug",
          "emptiesIn": "Leer in",
          "overheatsIn": "Überhitzt in",
          "refillsIn": "Aufgefüllt in",
          "recoversIn": "Erholt in",
          "regenLabel": "Regeneration",
          "shotsPerSecond": "%{rate} Schuss/s",
          "presets": {
            "title": "Voreinstellungen",
            "name": "Name der Voreinstellung",
            "save": "Voreinstellung speichern",
            "rename": "%{name} umbenennen",
            "delete": "%{name} löschen",
            "add": "Voreinstellung hinzufügen"
          },
          "title": "Energieplaner",
          "titleFor": "Energieplaner · %{name}",
          "open": "Energieplaner"
        },
        "title": "Energieverteilung",
        "scm": "SCM",
        "nav": "NAV",
        "reset": "Zurücksetzen",
        "auto": "Auto",
        "aimAssist": "Zielhilfe",
        "cooling": "Kühlung",
        "ir": "IR",
        "em": "EM",
        "cs": "CS",
        "csAxisHint": "Klicke, um die Achse zu wechseln (x / y / z)",
        "segmentsUsed": "%{used} / %{total} Segmente",
        "families": {
          "weapon": "Waffen",
          "shield": "Schilde",
          "engine": "Triebwerk",
          "radar": "Radar",
          "coolers": "Kühler",
          "qdrive": "Quantum-Antrieb",
          "qed": "QED",
          "emp": "EMP",
          "lifeSupport": "Lebenserhaltung",
          "miningLaser": "Bergbaulaser",
          "salvage": "Bergung",
          "tractorBeam": "Traktorstrahl",
          "towingbeam": "Abschleppstrahl"
        }
      },
      "defense": {
        "title": "Verteidigung",
        "shieldHp": "Schild-HP",
        "shieldHpSub": "%{count} Generatoren",
        "shieldRegen": "Regeneration",
        "shieldResistances": "Resistenz",
        "shieldAbsorption": "Absorption",
        "shieldFaces": "Schildseiten",
        "armor": "Panzerung",
        "deflection": "Ablenkung",
        "armorReduction": "Schadensreduzierung",
        "armorSelfResistance": "Eigenresistenz",
        "armorSignature": "Signatur",
        "countermeasures": "Gegenmaßnahmen",
        "countermeasureDuration": "Dauer",
        "countermeasure": {
          "decoy": "Täuschkörper",
          "noise": "Störsignal"
        },
        "damageType": {
          "physical": "Phys",
          "energy": "Energie",
          "distortion": "Dist.",
          "thermal": "Thermisch"
        },
        "signature": {
          "electromagnetic": "EM",
          "infrared": "IR",
          "crossSection": "CS"
        },
        "openDeflectionCheck": "Ablenkungsprüfung"
      },
      "penetrationCheck": {
        "title": "Durchschlagsprüfung",
        "intro": "— welche Schiffe durchschlagen seine Waffen?",
        "noWeapons": "Diese Ausrüstung hat keine Geschütze mit Schaden pro Schuss, die sich prüfen ließen.",
        "weapons": "Waffen",
        "shieldHealth": "Schildstärke des Ziels",
        "armorHealth": "Panzerungszustand des Ziels",
        "ship": "Schiff",
        "hoverHint": "Fahre über ein Schiff für die Aufschlüsselung je Waffe.",
        "note": "Jedes gewählte Geschütz wird nach denselben Regeln wie bei der Ablenkungsprüfung gegen die Schilde und die Panzerungsablenkung jedes Schiffs geprüft; ein Schiff gilt als durchschlagen, sobald eines davon durchkommt, und wird nach dem Geschütz sortiert, das am nächsten herankommt. Schiffe ohne Panzerung fehlen, da es keine Schwelle zu überschreiten gibt.",
        "sortBy": "Sortieren nach",
        "sort": {
          "margin": "Abstand",
          "ttk": "Zeit bis zur Zerstörung"
        },
        "ttk": "TTK",
        "effectiveHp": "Effektive HP",
        "shieldsDown": "Schilde unten",
        "ttkNote": "Die Zeit bis zur Zerstörung nutzt den anhaltenden Schaden pro Sekunde der gewählten Geschütze bei der aktuellen Energieverteilung, ausgehend von der oben eingestellten Schild- und Panzerungsgesundheit. Schilde nehmen den Schaden, den sie absorbieren, abzüglich ihres Widerstands, und reichen den Rest an die Panzerung weiter, die ihn trägt, bis sie bricht, und ihn dann an die Hülle weitergibt; Verzerrung zehrt nur an den Schilden. Schilde regenerieren nur, solange jedes Geschütz länger als ihre Regenerationsverzögerung pausiert, und einmal unten bleiben sie unten. Effektive HP sind der Rohschaden eines Typs, der nötig ist, um das Schiff zu zerstören, ohne Ablenkung. Strahlwaffen, mit TTK markiert, zählen nur für die Zeit bis zur Zerstörung: Die Panzerung lenkt sie nie ab, und ohne Alpha pro Schuss fließen sie nicht in den Abstand ein. Raketen fehlen."
      },
      "deflectionCheck": {
        "title": "Ablenkungsprüfung",
        "intro": "— welche Waffen durchdringen die Verteidigung?",
        "noArmor": "Dieses Schiff hat keine Panzerung, es wird also nichts abgelenkt.",
        "allSizes": "Alle",
        "deflected": "abgelenkt",
        "pierce": "durchdringen",
        "weapon": "Waffe",
        "boundary": "Ablenkungsgrenze",
        "alpha": "Alpha",
        "threshold": "Schwelle überschritten",
        "absorbed": "absorbiert",
        "versus": "vs",
        "hoverHint": "Fahre über eine Waffe, um die Aufschlüsselung nach Schadenstyp zu sehen.",
        "note": "Alpha wird pro Projektil verglichen, nachdem der Schild seinen Teil geschluckt hat — eine Waffe durchdringt, wenn sie die Ablenkung bei mindestens einem Schadenstyp übertrifft. Typen, die die Schilde vollständig absorbieren, erreichen die Panzerung nie und werden daher als absorbiert statt als abgelenkt aufgeführt: vom Schild gestoppt, nicht vom Rumpf. Die Schildabsorption wird über den veröffentlichten Min–Max-Bereich anhand der Schildgesundheit interpoliert, und die Panzerungsablenkung skaliert linear mit der Panzerungsgesundheit. Laserstrahlen sind ausgenommen — sie verursachen kontinuierlichen Schaden, es gibt also kein Alpha pro Schuss zum Prüfen.",
        "margin": "Abstand",
        "reachesArmor": "Erreicht die Panzerung",
        "stoppedByShields": "Schild absorbiert",
        "verdict": {
          "absorbed": "Absorbiert",
          "deflected": "Abgelenkt",
          "pierces": "Durchdrungen"
        },
        "shieldHealth": "Schildgesundheit",
        "armorHealth": "Panzerungsgesundheit",
        "absorb": "Absorb.",
        "defl": "Abl.",
        "type": "Typ",
        "size": "Größe"
      },
      "hull": {
        "category": {
          "vital": "Lebenswichtig",
          "secondary": "Sekundär",
          "breakable": "Zerstörbar",
          "subpart": "Unterteile",
          "cosmetic": "Kosmetisch"
        },
        "composition": "Rumpfzusammensetzung",
        "door": "Tür",
        "doors": "Türen",
        "doorsNote": "Zerstörbare Innentüren sind ein eigener Bereich — sie haben ihre eigene Gesundheit und zählen nicht zu den Rumpf-HP.",
        "doorsSub": "%{count} zerstörbar",
        "hullHp": "Rumpf-HP",
        "hullHpSub": "gesamt über alle Teile",
        "integrity": "Rumpfintegrität",
        "noHp": "keine HP",
        "parts": "Rumpfteile",
        "partsNote": "Die Teile sind nach Gesundheit sortiert; kosmetische Teile (Türen, Leitern, Klappen) haben keine eigene Gesundheit. Die Spieldateien enthalten keine Eltern-Kind-Verknüpfungen, daher ist dies eine flache Liste und kein Strukturbaum.",
        "partsSub": "über %{count} Kategorien",
        "partsTree": "Teile · damageMax",
        "showParts": "Rumpfteile anzeigen",
        "title": "Rumpf",
        "totalHp": "Gesamte Rumpf-HP"
      },
      "manufacturer": {
        "shortName": "Kurzname",
        "shipyard": "Werft",
        "longName": "Vollständiger Name",
        "code": "Code",
        "logo": "Logo",
        "logoOverridden": "Logo (überschrieben)",
        "icon": "Icon (Spieldateien)",
        "iconOverridden": "Icon (überschrieben)",
        "scRef": "SC Ref"
      },
      "announcement": {
        "title": "Titel",
        "body": "Text",
        "discordParts": "Discord-Nachrichten",
        "socialParts": "Social-Posts",
        "link": "Link",
        "notifyUsers": "In-App-Benachrichtigung",
        "postDiscord": "Discord-Updates-Kanal",
        "postBluesky": "Bluesky",
        "schedule": "Planen",
        "publishAt": "Senden am"
      },
      "fundingGoal": {
        "title": "Titel",
        "description": "Beschreibung",
        "amount": "Betrag",
        "currency": "Währung",
        "effectiveFrom": "Gültig ab",
        "endedAt": "Beendet am"
      },
      "homepageSetting": {
        "featuredModelsInfo": "Neben der Suche auf der Startseite gezeigt. Leer lassen, um zufällig aus allen Schiffen mit farbiger Schrägansicht zu wählen.",
        "featuredHidden": "Kein Schiff hervorheben",
        "featuredHiddenInfo": "Der Hero bleibt zentriert, ohne Schiff daneben.",
        "featuredRandom": "Zufällig wählen",
        "featuredRandomInfo": "Jeden Tag wird eines dieser Schiffe gezeigt, für alle Besucher dasselbe. Aus: immer das erste Schiff der Liste."
      },
      "gameEvent": {
        "title": "Titel",
        "description": "Beschreibung",
        "location": "Ort",
        "url": "Link",
        "category": "Kategorie",
        "startsAt": "Beginnt am",
        "endsAt": "Endet am",
        "coverImage": "Titelbild",
        "published": "Veröffentlicht",
        "publishedInfo": "Nur veröffentlichte Events erscheinen auf der Startseite."
      },
      "supporterContribution": {
        "name": "Unterstützer-Name",
        "user": "Verknüpftes Konto",
        "amount": "Betrag",
        "currency": "Währung",
        "anonymous": "Anonym",
        "recurring": "Wiederkehrend",
        "startedAt": "Beginnt am",
        "endedAt": "Endet am",
        "payerEmail": "E-Mail des Zahlenden",
        "claimKey": "Unterstützer-Token",
        "linkedVia": "Verknüpft über",
        "source": "Quelle",
        "note": "Interne Notiz",
        "stats": {
          "total": "Gesamt",
          "count": "Beiträge",
          "currentMonth": "Diesen Monat",
          "currentMonthCount": "%{count} Beiträge",
          "recurringCount": "Wiederkehrend",
          "anonymousCount": "Anonym"
        },
        "chart": {
          "contributions": "Beiträge",
          "goal": "Ziel"
        }
      },
      "itemPrice": {
        "price": "Preis",
        "location": "Standort",
        "locationUrl": "Standort-URL"
      },
      "video": {
        "url": "URL",
        "videoType": "Typ"
      },
      "modelModule": {
        "slot": "Slot",
        "noSlot": "Kein Slot",
        "slotsOnHull": "Modul-Slots an diesem Schiff: %{slots}",
        "noSlotsOnHull": "Die Spieldateien geben diesem Schiff keine Modul-Slots; jeder Name kann gesetzt werden",
        "name": "Name",
        "description": "Beschreibung",
        "price": "Preis",
        "pledgePrice": "Pledge-Preis",
        "productionStatus": "Produktionsstatus",
        "scKey": "SC Key",
        "cargo": "Fracht",
        "storeImage": "Shop-Bild",
        "active": "Aktiv?",
        "hidden": "Versteckt?"
      },
      "dockAddition": {
        "model": "Schiff",
        "hint": "Schiffe, die dieser Liegeplatz aufnimmt, obwohl seine Klasse sie nicht abdeckt.",
        "empty": "benannte Schiffe"
      },
      "dockCapacity": {
        "ladder": "Skala",
        "size": "Klasse",
        "quantity": "Wie viele",
        "display": "Als Beschriftung zeigen",
        "hint": "Wofür der Liegeplatz gebaut ist. Einträge sind Alternativen, keine Summe.",
        "empty": "Kapazitätseinträge"
      },
      "dockCapacityLadders": {
        "ship": "Schiffe",
        "vehicle": "Fahrzeuge"
      },
      "vehicleSizes": {
        "extra_extra_small": "Extra extra klein (XXS)",
        "extra_small": "Extra klein (XS)",
        "small": "Klein (S)",
        "medium": "Mittel (M)",
        "large": "Groß (L)",
        "extra_large": "Extra groß (XL)",
        "extra_extra_large": "Extra extra groß (XXL)"
      },
      "dock": {
        "name": "Name",
        "dockType": "Dock-Typ",
        "shipSize": "Schiffsgröße",
        "access": "Zugang",
        "length": "Länge",
        "beam": "Breite",
        "height": "Höhe",
        "unmeasured": "nicht vermessen"
      },
      "modelPosition": {
        "name": "Name",
        "positionType": "Positionstyp",
        "source": "Quelle",
        "position": "Sortierreihenfolge",
        "types": {
          "pilot": "Pilot",
          "copilot": "Co-Pilot",
          "turret_gunner": "Geschützturm-Schütze",
          "engineer": "Ingenieur",
          "gunner": "Schütze",
          "loadmaster": "Ladungsmeister",
          "passenger": "Passagier",
          "operator": "Operator",
          "custom": "Benutzerdefiniert"
        }
      },
      "modelUpgrade": {
        "name": "Name",
        "description": "Beschreibung",
        "pledgePrice": "Pledge-Preis",
        "active": "Aktiv?",
        "hidden": "Versteckt?"
      },
      "modelModulePackage": {
        "name": "Name",
        "description": "Beschreibung",
        "pledgePrice": "Pledge-Preis",
        "modules": "Module",
        "active": "Aktiv?",
        "hidden": "Versteckt?"
      },
      "cargoHold": {
        "offsetX": "Offset X (SCU)",
        "offsetY": "Offset Y (SCU)",
        "offsetZ": "Offset Z (SCU)",
        "rotation": "Rotation (°)"
      },
      "modelLoaner": {
        "hidden": "Versteckt?",
        "loanerModel": "Leihmodell"
      },
      "modelSnubCraft": {
        "snubCraft": "Snub Craft"
      },
      "modelPaint": {
        "hidden": "Versteckt?",
        "active": "Aktiv?",
        "onSale": "Im Angebot",
        "pledgePrice": "Pledge-Preis",
        "productionStatus": "Produktionsstatus",
        "productionNote": "Produktionshinweis",
        "copyHint": "Wähle das Zielschiff, auf das diese Lackierung kopiert werden soll. Die Lackierungsdaten werden beim Kopieren nicht verändert.",
        "bulkCopyHint": "Wähle das Zielschiff, auf das diese %{count} Lackierungen kopiert werden sollen. Die Lackierungsdaten werden beim Kopieren nicht verändert.",
        "copySameModel": "Das Zielschiff muss sich vom Ausgangsschiff unterscheiden."
      },
      "component": {
        "temperature": {
          "minCooling": "Kühlung ab",
          "overheat": "Überhitzt bei",
          "warning": "Warnung bei",
          "recovery": "Erholt bei",
          "misfireRange": "Fehlfunktionsbereich",
          "irStart": "IR ab",
          "irPerKelvin": "IR pro K"
        },
        "misfire": {
          "heat": "Hitze",
          "distortion": "Verzerrung",
          "damage": "Schaden",
          "wear": "Verschleiß",
          "window": "Zeitfenster",
          "hint": "Der Wert jedes Zustands, ab dem die Komponente Fehlfunktionen haben kann, wie die Spieldateien ihn angeben."
        },
        "availability": {
          "retired": "Preise werden für den Build erfasst, auf dem der Katalog steht, und dieses Teil ist nicht darin.",
          "craftedOnly": "Kein Terminal verkauft dieses Teil – es wird nach dem Rezept unten hergestellt.",
          "none": "Kein Terminal kauft oder verkauft dieses Teil."
        },
        "notRecordedYet": "Wird erst seit dem Start der Aufzeichnung erfasst, eine Komponente kann also noch nichts haben.",
        "size": "Size: %{size}",
        "grade": "Qualität",
        "hidden": "Versteckt?",
        "componentType": "Komponententyp",
        "componentSubType": "Komponenten-Untertyp",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image",
        "itemClass": "Klasse",
        "category": "Kategorie",
        "subType": "Untertyp",
        "retired": "Nicht mehr im aktuellen Build",
        "noMetrics": "Für diese Komponente sind keine Werte hinterlegt.",
        "integrity": "Integrität",
        "durability": {
          "health": "Trefferpunkte",
          "mass": "Masse",
          "physical": "Physisch",
          "energy": "Energie",
          "distortion": "Distortion",
          "thermal": "Thermisch",
          "biochemical": "Biochemisch",
          "stun": "Betäubung",
          "repairTime": "Reparaturzeit",
          "repairsTo": "Repariert auf",
          "maxRepairs": "Max. Reparaturen",
          "disableAt": "Ausfall bei",
          "warningAt": "Warnung bei",
          "recoversBelow": "Erholt sich unter",
          "decayRate": "Abbaurate",
          "decayDelay": "Abbauverzögerung"
        },
        "durabilityChanges": {
          "health": "Trefferpunkte",
          "mass": "Masse (kg)",
          "resistancesPhysical": "Erlittener physischer Schaden",
          "resistancesEnergy": "Erlittener Energieschaden",
          "resistancesDistortion": "Erlittener Distortion-Schaden",
          "resistancesThermal": "Erlittener thermischer Schaden",
          "resistancesBiochemical": "Erlittener biochemischer Schaden",
          "resistancesStun": "Erlittener Betäubungsschaden",
          "selfRepairTime": "Selbstreparaturzeit (s)",
          "selfRepairHealthRatio": "Selbstreparatur stellt her auf",
          "selfRepairMaxRepairs": "Max. Selbstreparaturen",
          "distortionMaximum": "Distortion-Ausfallschwelle",
          "distortionWarningRatio": "Distortion-Warnschwelle",
          "distortionRecoveryRatio": "Distortion-Erholungsschwelle",
          "distortionDecayRate": "Distortion-Abbaurate (/s)",
          "distortionDecayDelay": "Distortion-Abbauverzögerung (s)"
        }
      },
      "hardpoint": {
        "legend": {
          "headline": "Legende",
          "slotTaken": "Slot belegt",
          "slotAvailable": "Slot frei"
        },
        "size": "Größe",
        "rackSize": "Rack-Größe",
        "details": "Details",
        "group": "Gruppe",
        "thrusters": {
          "thrust": "Schub",
          "subTypes": {
            "JointThruster": "Joint",
            "FixedThruster": "Fix",
            "FlexThruster": "Flex",
            "Retro": "Fix",
            "Light": "Light"
          },
          "fuelBurn": "Treibstoffverbrauch",
          "mode": "Modus",
          "vtolOnly": "Nur VTOL",
          "vectorPitch": "Schubvektor Nicken",
          "vectorYaw": "Schubvektor Gieren"
        },
        "refuelBoom": {
          "captureRadius": "Fangradius",
          "fuelFlowRate": "Treibstoff-Durchflussrate",
          "quantumFuelFlowRate": "Quantum-Durchflussrate"
        },
        "controllers": {
          "faceType": "Schildtyp",
          "faces": {
            "bubble": "Blase",
            "quadrant": "Quadranten"
          },
          "reconfigurationCooldown": "Umverteilung",
          "armedMissiles": "Scharfe Raketen",
          "launchCooldown": "Startabklingzeit",
          "lockAngle": "Aufschaltwinkel"
        },
        "countermeasureStats": {
          "duration": "Dauer",
          "spawnDelay": "Entfaltung nach",
          "infrared": "IR-Signatur",
          "electromagnetic": "EM-Signatur",
          "crossSection": "Querschnitt"
        },
        "turrets": {
          "turnRate": "Drehrate",
          "control": "Steuerung",
          "yawRange": "Gierbereich",
          "pitchRange": "Nickbereich",
          "limitsVary": "abhängig von der Drehung",
          "gunPorts": "Waffenplätze"
        },
        "weapons": {
          "dps": "DPS",
          "burstDps": "Burst DPS",
          "sustainedDps": "Dauer-DPS",
          "efficiency": "Effizienz",
          "penetration": "Durchschlag",
          "fireRate": "Feuerrate",
          "speed": "Geschwindigkeit",
          "range": "Reichweite",
          "ammo": "Munition",
          "ammoCost": "Munitionskosten",
          "magazineDamage": "Magazinschaden",
          "timeToEmpty": "Zeit bis leer",
          "spread": "Streuung",
          "spreadFirstShot": "Streuung erster Schuss",
          "spreadPerShot": "Streuung/Schuss",
          "spreadRecovery": "Streuungsabbau",
          "pool": "Kondensator",
          "maxRegen": "Max. Regen/s",
          "costPerShot": "Energie/Schuss",
          "heatPerShot": "Hitze/Schuss",
          "heatPerSecond": "Hitze/s",
          "gimbalFireRate": "Feuerrate (Gimbal)",
          "gimbalSpread": "Streuung (Gimbal)",
          "spreadMin": "min.",
          "spreadMax": "max.",
          "aimAssist": "Zielhilfe",
          "closeAimAssist": "Zielhilfe (Nahbereich)",
          "chargeTime": "Ladezeit",
          "fullDamageRange": "Volle DMG-Reichweite",
          "zeroDamageRange": "Null-DMG-Reichweite",
          "damagePhysical": "Physisch",
          "damageEnergy": "Energie",
          "damageDistortion": "Distortion",
          "damageThermal": "Thermisch"
        },
        "missiles": {
          "damage": "Schaden",
          "speed": "Geschwindigkeit",
          "range": "Reichweite",
          "lockRange": "Erfassungsreichweite",
          "lockTime": "Erfassungszeit",
          "trackingSignal": "Tracking",
          "lockAngle": "Erfassungskegel",
          "signalResilience": "Signalresistenz",
          "boostPhase": "Boost-Phase",
          "terminalPhase": "Endphase",
          "lifetime": "Lebensdauer",
          "fuel": "Treibstoff",
          "dumbfire": "Ungelenkt",
          "dumbfireAllowed": "Erlaubt",
          "dumbfireBlocked": "Nicht erlaubt",
          "blastRadius": "Explosionsradius",
          "armTime": "Schärfzeit",
          "safetyDistance": "Sicherheitsabstand"
        },
        "bombs": {
          "maxDropAngle": "Max. Abwurfwinkel"
        },
        "missileRacks": {
          "launchDelay": "Startverzögerung",
          "ignition": "Motorzündung",
          "ignitesOnRack": "Am Träger",
          "ignitesAfterRelease": "Nach dem Ausklinken"
        },
        "tractorBeams": {
          "maxForce": "Max. Kraft",
          "minForce": "Min. Kraft",
          "range": "Reichweite",
          "cone": "Kegel",
          "tetherBreak": "Abrissgrenze",
          "cargoForce": "Frachtkraft",
          "cargoRange": "Frachtreichweite",
          "towForce": "Schleppkraft",
          "towDistance": "Schleppreichweite",
          "quantumTowMass": "QT-Massenlimit",
          "rotationSpeed": "Rotation",
          "moveSpeed": "Bewegungstempo"
        },
        "shields": {
          "hp": "HP",
          "regen": "Regen",
          "regenTime": "Regen-Zeit",
          "downedRegenDelay": "Ausfall-Verzögerung",
          "damagedRegenDelay": "Schadens-Verzögerung",
          "resistancePhysical": "Phys. Res.",
          "resistanceEnergy": "Energie-Res.",
          "resistanceDistortion": "Dist.-Res.",
          "decay": "Abbau",
          "absorption": {
            "physical": "Physische Absorption",
            "energy": "Energie-Absorption",
            "distortion": "Verzerrungs-Absorption"
          }
        },
        "coolers": {
          "coolingRate": "Kühlrate"
        },
        "powerPlants": {
          "output": "Leistung",
          "pips": "Pips"
        },
        "flightControllers": {
          "scmSpeed": "SCM-Geschwindigkeit",
          "boostSpeed": "Boost-Geschwindigkeit",
          "navSpeed": "Nav-Geschwindigkeit",
          "rotation": "Nicken / Gieren / Rollen",
          "boostedRotation": "Nicken / Gieren / Rollen mit Boost",
          "boostCapacity": "Boost-Kapazität",
          "boostRegen": "Boost-Regeneration",
          "boostRegenDelay": "Boost-Regenerationsverzögerung",
          "boostRamp": "Boost-Anlauf / -Auslauf"
        },
        "quantumDrives": {
          "speed": "Geschwindigkeit",
          "range": "Reichweite",
          "fuelConsumption": "Verbrauch",
          "spoolUpTime": "Spool-Up",
          "cooldownTime": "Abklingzeit",
          "splineSpeed": "Orbit",
          "accel": "Beschl.",
          "engageSpeed": "Eintrittsgeschwindigkeit",
          "calibrationRate": "Kalibrierrate",
          "disconnectRange": "Abbruchdistanz",
          "interdictionTime": "Unterbrechungsdauer",
          "splineAccel": "Orbit-Beschleunigung",
          "splineSpoolUpTime": "Orbit-Hochfahren",
          "splineCooldownTime": "Orbit-Abklingzeit",
          "splineInterdictionTime": "Orbit-Unterbrechung",
          "jumpHeat": "Sprungwärme"
        },
        "jumpDrives": {
          "fuelEfficiency": "Treibstoffeffizienz",
          "alignRate": "Ausrichtungsrate",
          "tuneRate": "Abstimmungsrate",
          "alignDecay": "Ausrichtungsverfall",
          "tuneDecay": "Abstimmungsverfall",
          "exitSpeed": "Austrittsgeschwindigkeit",
          "maxTunnelSpeed": "Max. Tunnelgeschwindigkeit",
          "respoolTime": "Neustart"
        },
        "radar": {
          "aimAssistRange": "Zielhilfe-Reichweite",
          "ir": "IR",
          "em": "EM",
          "cs": "CS",
          "rs": "RS",
          "passive": "Passive Erfassung",
          "active": "Aktive Erfassung",
          "aimAssistBuffer": "Zielhilfe-Puffer",
          "sensitivityModifier": "Empfindlichkeitsmodifikator",
          "contactGroups": {
            "GroundVehicle": "Bodenfahrzeuge"
          }
        },
        "armor": {
          "hp": "HP",
          "physical": "Physisch",
          "energy": "Energie",
          "distortion": "Distortion",
          "thermal": "Thermisch",
          "deflectPhysical": "Phys. Abl.",
          "deflectEnergy": "Energie-Abl.",
          "selfPhysical": "Eigen-Res. Phys.",
          "selfEnergy": "Eigen-Res. Energie"
        },
        "fuelIntakes": {
          "pushRate": "Förderrate",
          "minRate": "Min. Rate"
        },
        "sources": {
          "game_files": "Spieldateien",
          "ship_matrix": "Ship Matrix"
        },
        "fuelTanks": {
          "hydrogen": "Hydrogen-Treibstofftank",
          "quantum": "Quantum-Treibstofftank"
        },
        "jumpDrive": "Sprungantrieb",
        "maxContainerSize": "Max. Containergröße",
        "groups": {
          "avionic": "Avionik",
          "system": "Systeme",
          "propulsion": "Antrieb",
          "thruster": "Triebwerk",
          "weapon": "Waffen",
          "defense": "Verteidigung",
          "other": "Fracht",
          "auxiliary": "Hilfssysteme",
          "seat": "Sitze",
          "external_fuel_tank": "Externe Treibstofftanks",
          "ore_pod": "Erzbehälter",
          "module": "Module",
          "salvage": "Bergung",
          "refuel_boom": "Betankungsausleger"
        },
        "types": {
          "radar": "Radar",
          "computers": "Computer",
          "power_plants": "Kraftwerke",
          "coolers": "Kühler",
          "shield_generators": "Schildgeneratoren",
          "fuel_intakes": "Treibstoffeinlässe",
          "fuel_tanks": "Treibstofftanks",
          "quantum_drives": "Quantum-Antriebe",
          "jump_modules": "Sprungmodule",
          "jumpdrive": "Sprungmodule",
          "quantum_fuel_tanks": "Quantum-Treibstofftanks",
          "main_thrusters": "Haupttriebwerke",
          "maneuvering_thrusters": "Manövriertriebwerke",
          "weapons": "Waffen",
          "turrets": "Geschütztürme",
          "missiles": "Raketen",
          "utility_items": "Hilfsgeräte",
          "utility": "Hilfsgeräte",
          "emp": "EMP",
          "qed": "QED"
        },
        "moduleSlotEmpty": "— Modul auswählen —",
        "selectModule": "Modul auswählen",
        "moduleStock": "Wie ausgeliefert",
        "moduleStockHint": "Slot bleibt, wie das Schiff geliefert wird",
        "categories": {
          "radar": "Radar",
          "armor": "Panzerung",
          "relay": "Relais",
          "countermeasures": "Gegenmaßnahmen",
          "lifesupport": "Lebenserhaltung",
          "selfdestruct": "Selbstzerstörung",
          "batteries": "Batterien",
          "computers": "Computer",
          "powerplant": "Kraftwerke",
          "cooler": "Kühler",
          "module": "Module",
          "shieldgenerator": "Schildgeneratoren",
          "fuel_intakes": "Treibstoffeinlässe",
          "fueltanks": "Treibstofftanks",
          "external_fuel_tanks": "Externe Treibstofftanks",
          "ore_pods": "Erzbehälter",
          "salvage_storage": "Bergungsspeicher",
          "refuel_boom": "Betankungsausleger",
          "quantumdrive": "Quantum-Antriebe & Sprungmodule",
          "jump_modules": "Sprungmodule",
          "jumpdrive": "Sprungmodule",
          "quantum_fuel_tanks": "Quantum-Treibstofftanks",
          "main_thrusters": "Haupttriebwerke",
          "maneuvering_thrusters": "Manövriertriebwerke",
          "retro_thrusters": "Retro-Triebwerke",
          "vtol_thrusters": "VTOL-Triebwerke",
          "weapons": "Waffen",
          "weapon_mounts": "Waffenhalterungen",
          "turret": "Geschütztürme",
          "missiles": "Raketen",
          "missile_racks": "Raketenträger",
          "utility_items": "Hilfsgeräte",
          "utility": "Hilfsgeräte",
          "emp": "EMP",
          "quantumenforcementdevice": "QED",
          "salvagefillerstation": "Bergungsfüllstation",
          "cargogrid": "Frachtraster",
          "controller": "Flight Blades",
          "seat": "Sitze",
          "thrusters": "Triebwerke",
          "bombcompartments": "Bombenschächte"
        },
        "name": "Name",
        "category": "Kategorie",
        "source": "Quelle",
        "powerConsumption": "Energieverbrauch",
        "powerMinimumFraction": "Verbrauch im Leerlauf",
        "signatureEm": "EM-Signatur",
        "signatureIr": "IR-Signatur",
        "mining": {
          "fracturePower": "Bruchleistung",
          "extractionPower": "Extraktionsleistung",
          "range": "Reichweite",
          "chargeTime": "Aufladen / Entladen",
          "moduleSlots": "Modulplätze",
          "activation": "Typ",
          "active": "Aktiv",
          "passive": "Passiv",
          "charges": "Anwendungen",
          "duration": "Dauer",
          "modifiers": {
            "instability": "Instabilität",
            "resistance": "Widerstand",
            "optimalChargeWindow": "Optimales Ladefenster",
            "optimalChargeRate": "Optimale Laderate",
            "catastrophicChargeRate": "Kritische Laderate",
            "shatterDamage": "Splitterschaden",
            "inertMaterials": "Inertes Material"
          }
        },
        "salvage": {
          "salvageSpeed": "Bergungsgeschwindigkeit",
          "radius": "Strahlradius",
          "extractionEfficiency": "Extraktionseffizienz"
        },
        "utility": {
          "capacity": "Kapazität"
        },
        "selfDestruct": {
          "damage": "Schaden",
          "radius": "Explosionsradius",
          "time": "Zündverzögerung"
        },
        "quantumEnforcement": {
          "jammerRange": "Störsender-Reichweite",
          "pulseRadius": "Impulsradius",
          "chargeTime": "Ladezeit",
          "cooldownTime": "Abklingzeit"
        },
        "emp": {
          "distortionDamage": "Verzerrungsschaden",
          "radius": "Radius",
          "chargeTime": "Ladezeit",
          "unleashTime": "Auslösezeit",
          "cooldownTime": "Abklingzeit"
        },
        "lifeSupport": {
          "output": "Leistung"
        },
        "powerRanges": "Leistungskurve (Niedrig / Mittel / Hoch)",
        "powerSegments": "Seg."
      },
      "blank": {
        "propulsion": "Kein Antrieb vorhanden",
        "modular": "Kein Modular vorhanden",
        "fleetInvites": "Keine Einladungen vorhanden"
      },
      "user": {
        "displayName": "Anzeigename",
        "displayNameInfo": "Wird statt deines Benutzernamens in deinem öffentlichen Hangar, auf deinen Widmungstafeln und in Flotten-Mitgliederlisten angezeigt.",
        "hangarDefaultSort": "Standard-Reihenfolge",
        "hangarDefaultSortInfo": "Zieh ein Schiff an seinem Griff, um es umzusortieren. Verfügbar, solange die eigene Reihenfolge aktiv und kein Filter gesetzt ist.",
        "hangarDefaultSortOptions": {
          "standard": "Standard (Flaggschiff zuerst, dann Name)",
          "asc": "%{field}, aufsteigend",
          "desc": "%{field}, absteigend"
        },
        "rsiHandle": "Handle",
        "rsiHandleVerified": "Über Citizen iD verifiziert",
        "rsiHandleVerifiedViaProfile": "Über das RSI-Profil verifiziert",
        "rsiVerification": {
          "title": "RSI-Handle verifizieren",
          "token": "Verifizierungscode",
          "verifiedSince": "Verifiziert seit %{date}",
          "revokeCitizenidQuestion": "Kommt beim nächsten Citizen-iD-Login zurück. Sicher?",
          "openProfileSettings": "RSI-Profil bearbeiten",
          "steps": {
            "copy": "Kopiere deinen Verifizierungscode",
            "paste": "Füge ihn in die Kurzbiografie deines RSI-Profils ein. Sobald dein Handle verifiziert ist, kannst du ihn wieder entfernen.",
            "check": "Prüfe die Bürgerseite von %{handle}"
          },
          "extension": {
            "title": "Mit der FleetYards-Sync-Erweiterung verifizieren",
            "verify": "Mit Erweiterung verifizieren",
            "description": "Die Erweiterung fügt deinen Code in die Biografie des RSI-Kontos ein, mit dem dieser Browser angemeldet ist, prüft deine Bürgerseite und entfernt den Code danach wieder.",
            "detecting": "Suche nach der FleetYards-Sync-Erweiterung",
            "install": "Installiere die FleetYards-Sync-Erweiterung, um dein Handle mit einem Klick zu verifizieren.",
            "update": "Aktualisiere die FleetYards-Sync-Erweiterung, um dein Handle mit einem Klick zu verifizieren: Die installierte Version unterstützt das noch nicht.",
            "handleMismatch": "Dieser Browser ist bei RSI als %{rsiHandle} angemeldet, nicht als %{handle}. Melde dich bei RSI als %{handle} an oder verifiziere unten von Hand.",
            "notSignedIn": "Melde dich in diesem Browser bei RSI an, um mit der Erweiterung zu verifizieren, oder verifiziere unten von Hand.",
            "bioTooLong": "Deine RSI-Biografie ist zu lang, um den Code einzufügen. Kürze sie oder verifiziere unten von Hand.",
            "bioUnreadable": "Deine RSI-Biografie enthält Formatierungen, die die Erweiterung nicht unverändert erhalten kann. Verifiziere unten von Hand.",
            "failed": "Die Erweiterung konnte deine RSI-Biografie nicht ändern. Versuche es erneut oder verifiziere unten von Hand.",
            "removeFailed": "Die Erweiterung konnte den Code nicht aus deiner RSI-Biografie entfernen. Entferne ihn dort von Hand.",
            "manual": "Oder von Hand verifizieren:"
          },
          "statuses": {
            "pending": "Deine Bürgerseite wird geprüft…",
            "token_missing": "Der Code steht noch nicht in deiner Biografie. RSI kann einige Minuten brauchen, bis eine Änderung sichtbar ist.",
            "handle_mismatch": "Die Seite, die RSI geliefert hat, gehört zu einem anderen Handle.",
            "not_found": "RSI kennt keinen Bürger mit diesem Handle.",
            "failed": "Deine Bürgerseite konnte nicht geprüft werden. Versuche es in einer Minute erneut."
          }
        },
        "location": "Standort",
        "currentSystem": "Aktueller Ort im Spiel",
        "tester": "Tester?",
        "maintainer": "Maintainer?",
        "avatar": "Avatar",
        "unconfirmedEmail": "Unbestätigte E-Mail",
        "saleNotify": "Ich möchte Angebotsbenachrichtigungen erhalten",
        "publicHangar": "Öffentlicher Hangar aktiviert",
        "publicHangarLoaners": "Leihschiff-Hinweis im öffentlichen Hangar anzeigen",
        "publicHangarStats": "Öffentliche Hangar-Statistiken aktiviert",
        "publicWishlist": "Öffentliche Wunschliste aktiviert",
        "hideOwner": "Besitz für Flotten verbergen",
        "tracking": "Anonyme Nutzungsstatistik erlauben",
        "showOnlineStatus": "Anzeigen, wenn ich online bin",
        "supporterListed": "Unterstützerseite",
        "supporterListedPlatform": "Wie beim Spenden gewählt",
        "supporterListedShown": "Meinen Benutzernamen zeigen",
        "supporterListedHidden": "Mich nicht zeigen",
        "onlineStatus": "Online-Status",
        "online": "Online",
        "offline": "Offline",
        "lastActiveAt": "Zuletzt aktiv",
        "confirmedAt": "Bestätigt am",
        "dateFormat": "Datumsformat",
        "dateFormats": {
          "dmy_dots": "31.12.2026",
          "dmy_slash": "31/12/2026",
          "mdy_slash": "12/31/2026",
          "ymd_dash": "2026-12-31"
        },
        "friendsHangar": "Hangar für Freunde sichtbar",
        "friendsHangarStats": "Hangar-Statistiken für Freunde sichtbar",
        "friendsWishlist": "Wunschliste für Freunde sichtbar"
      },
      "adminUser": {
        "superAdmin": "Super-Admin",
        "passwordConfirmation": "Passwort bestätigen"
      },
      "vehicle": {
        "cargoWithModules": "%{cargo} (%{withModules} mit Modulen)",
        "customOrder": "Eigene",
        "name": "Name",
        "states": "Zustände",
        "serial": "Seriennummer",
        "owner": "befehligt von",
        "flagship": "Flaggschiff",
        "wanted": "Gewünscht",
        "loaner": "Leihschiff",
        "bundled": "Mitgeliefert",
        "bundledWith": "Mitgeliefert mit %{parent}",
        "hiddenByUser": "Aus deinem Hangar ausgeblendet",
        "public": "Öffentlich sichtbar",
        "fullPublic": "Öffentlich sichtbar inkl. Name",
        "private": "Nicht öffentlich sichtbar",
        "publicShort": "Öffentlich",
        "saleNotifyOn": "Angebotsbenachrichtigung an",
        "saleNotifyOff": "Angebotsbenachrichtigung aus",
        "nameVisible": "Öffentlich sichtbar",
        "hidden": "Versteckt?",
        "saleNotify": "Ich möchte Angebotsbenachrichtigungen erhalten",
        "hangarGroups": "Gruppen",
        "ownedPaintsSelect": {
          "label": "Eigene Lackierungen",
          "pledged": "Aus einem Paket",
          "empty": "Keine Lackierungen gefunden"
        },
        "modelPaintSelect": {
          "nullablePrompt": "Lackierung auswählen",
          "label": "Lackierung"
        },
        "bulkGroupEdit": {
          "hint": "Bestehende Gruppen werden überschrieben!"
        },
        "hasLoaners": "Leihschiffe",
        "boughtViaSelect": {
          "label": "Gekauft über"
        }
      },
      "image": {
        "active": "Aktiv?",
        "background": "Als Hintergrund verwenden?",
        "caption": "Beschriftung",
        "enabled": "Aktiviert?",
        "file": "Bilddatei",
        "global": "Global?",
        "delete": "Löschen",
        "start": "Starten",
        "cancel": "Abbrechen",
        "processing": "Verarbeitung...",
        "error": "Fehler",
        "name": "Name",
        "size": "Dateigröße",
        "dropzone": "Bilder hier ablegen",
        "cancelUpload": "Upload abbrechen",
        "startUpload": "Upload starten",
        "selectImages": "Bilder hinzufügen...",
        "selectFolder": "Ordner hinzufügen..."
      },
      "signup": {
        "link": "Haben Sie kein Konto?",
        "privacyPolicy": "Durch das Erstellen eines FleetYards-Kontos stimmen Sie unserer"
      },
      "privacyPolicy": "Datenschutzerklärung",
      "login": "Benutzername oder E-Mail",
      "username": "Benutzername",
      "twoFactorCode": "Zwei-Faktor-Code",
      "confirmationCode": "Bestätigungscode",
      "email": "E-Mail",
      "avatar": "Avatar",
      "alreadyRegistered": "Haben Sie bereits ein Konto?",
      "password": "Passwort",
      "passwordConfirmation": "Passwort bestätigen",
      "rememberMe": "Angemeldet bleiben",
      "emptyList": "Keine %{name} vorhanden",
      "all": "Alle",
      "supportUs": "Support FleetYards.net",
      "account": {
        "destroyInfo": "If you want to delete Your Account and remove all your Information from Fleetyards.net and its Services click the Button below. Be aware of that this is a permanent Action and can't be reverted.",
        "calendarSubscription": {
          "intro": "Erzeuge einen privaten Link, um die Events, für die du angemeldet bist, in deiner persönlichen Kalender-App zu sehen (Apple Kalender, Google Kalender, Outlook).",
          "howTo": "Füge den Link in deiner Kalender-App unter „Kalender abonnieren“ oder „Per URL hinzufügen“ ein. Wer diesen Link hat, sieht die Events, für die du angemeldet bist — halte ihn privat."
        },
        "supporterNomination": {
          "label": "Flottenunterstützung",
          "hint": "Deren Mitglieder erhalten die Flotten-Funktionen, solange eine Spende aktiv ist. Du kannst vor dem Spenden wählen.",
          "perDonation": "Pro Spende",
          "perDonationHint": "Eine einzelne Spende kann eine andere Flotte unterstützen als deine übliche.",
          "fleet": "Unterstützte Flotte"
        },
        "supporterClaimKey": {
          "signedOut": "Bitte melde dich an, um deinen persönlichen Unterstützer-Schlüssel zu erhalten.",
          "patreonNote": "wird über deine E-Mail-Adresse zugeordnet, kein Schlüssel nötig",
          "label": "Dein Schlüssel",
          "hint": "Füge ihn der Nachricht einer PayPal-, Ko-fi- oder Buy-me-a-coffee-Zahlung hinzu, dann wird sie deinem Konto zugeordnet. Bei Patreon geschieht das über deine E-Mail-Adresse.",
          "listed": "Ob dein Benutzername auf der Unterstützerseite erscheint, entscheidest du:",
          "listedLink": "Privatsphäre-Einstellungen"
        }
      },
      "filters": {
        "locations": {
          "name": "Orte durchsuchen",
          "system": "System",
          "parent": "Innerhalb von",
          "kind": "Art",
          "starmap": "Karte im Spiel",
          "shownOnStarmap": "Auf der Karte sichtbar",
          "hiddenOnStarmap": "Auf der Karte verborgen"
        },
        "components": {
          "name": "Name",
          "buyPriceGt": "Kaufpreis >=",
          "buyPriceLt": "Kaufpreis <=",
          "sellPriceGt": "Verkaufspreis >=",
          "sellPriceLt": "Verkaufspreis <=",
          "storeImageBlank": "Ohne Shop-Bild?",
          "description": "Beschreibung",
          "manufacturer": "Hersteller",
          "category": "Kategorie",
          "subType": "Untertyp"
        },
        "shops": {
          "name": "Name",
          "type": "Typ",
          "model": "Schiff",
          "equipment": "Ausrüstung",
          "component": "Komponente",
          "commodity": "Ware",
          "commodityType": "Warentyp"
        },
        "shopCommodities": {
          "commodityType": "Warentyp",
          "equipment": "Ausrüstung",
          "component": "Komponente",
          "commodity": "Ware",
          "model": "Schiff",
          "name": "Name"
        },
        "shopItems": {
          "category": "Kategorie",
          "subCategory": "Unterkategorie",
          "name": "Name",
          "manufacturer": "Hersteller"
        },
        "stations": {
          "name": "Name",
          "type": "Stationstyp",
          "shops": "Geschäfte",
          "docks": "Andockplätze"
        },
        "vehicles": {
          "name": "Name or Ship name",
          "lengthLt": "Length <=",
          "cargoGt": "SCU >=",
          "cargoLt": "SCU <=",
          "lengthGt": "Length >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "Preis <=",
          "priceGt": "Preis >=",
          "wanted": "Gewünscht",
          "hidden": "Versteckt",
          "public": "Öffentlich",
          "group": "Gruppe",
          "loaner": "Leihschiffe",
          "bundled": "Mitgelieferte Snub Crafts",
          "hiddenByUser": "Ausgeblendete Schiffe",
          "boughtVia": "Gekauft über?",
          "image": "Bild",
          "imageSources": {
            "custom": "Nicht Standard",
            "upload": "Hochgeladen",
            "gallery": "Aus der Galerie",
            "default": "Standard"
          },
          "dedication": "Widmungstafel"
        },
        "models": {
          "name": "Name",
          "cargoGt": "SCU >=",
          "cargoLt": "SCU <=",
          "classification": "Klassifizierung",
          "focus": "Fokus",
          "manufacturer": "Hersteller",
          "onSale": "Im Angebot",
          "ingameOnly": "Nur im Spiel",
          "canLandOnPlanets": "Kann auf Planeten landen",
          "size": "Größe",
          "dockSize": "Dock-Größe",
          "price": "Preis",
          "pledgePrice": "Pledge-Preis",
          "productionStatus": "Produktionsstatus",
          "lengthLt": "Length <=",
          "lengthGt": "Length >=",
          "beamLt": "Beam <=",
          "beamGt": "Beam >=",
          "heightLt": "Height <=",
          "heightGt": "Height >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "Preis <=",
          "priceGt": "Preis >=",
          "willItFit": "Will it Fit?",
          "withCargo": "Mit Fracht?",
          "scKeyBlank": "Ohne SC-Key?",
          "positionsNeedCuration": "Positionen kuratierungsbedürftig?",
          "fleetchartImageBlank": "Ohne Flottenübersicht-Bild?",
          "holoBlank": "Ohne Holo?",
          "frontViewBlank": "Ohne Frontansicht-Bild?",
          "topViewColoredBlank": "Ohne farbige Draufsicht?",
          "vehicleSize": "Fahrzeuggröße",
          "dimensionsDrifted": "Maße weichen von den Spieldateien ab",
          "dimensionsMeasuredAtNull": "Ohne gemessene Maße?"
        },
        "modelModules": {
          "name": "Name"
        },
        "manufacturers": {
          "name": "Name",
          "withModels": "Mit Modellen",
          "logoBlank": "Ohne Logo"
        },
        "supporterContributions": {
          "name": "Nach Name suchen",
          "recurring": "Wiederkehrend",
          "anonymous": "Anonym",
          "startedAtGteq": "Beginnt ab",
          "startedAtLteq": "Beginnt bis",
          "user": "Verknüpftes Konto",
          "linked": "Konto-Verknüpfung",
          "linkedOnly": "Verknüpft",
          "linkedVia": "Verknüpft über",
          "unlinkedOnly": "Nicht verknüpft",
          "sourceStated": "Plattform angegeben",
          "sourceStatedOnly": "Plattform angegeben",
          "sourceUnspecifiedOnly": "Plattform nicht angegeben",
          "source": "Quelle"
        },
        "adminNotifications": {
          "search": "Suchen"
        },
        "images": {
          "model": "Schiff"
        },
        "users": {
          "search": "Suchen",
          "username": "Benutzername",
          "email": "E-Mail",
          "rsiHandle": "RSI-Handle"
        },
        "fleets": {
          "name": "Name",
          "fid": "FID",
          "memberCountGteq": "Mindestens Mitglieder",
          "memberCountLteq": "Höchstens Mitglieder",
          "rsiVerified": "Bei RSI verifiziert",
          "publicFleet": "Öffentlich",
          "recruiting": "Rekrutiert",
          "createdOnGteq": "Erstellt ab",
          "createdOnLteq": "Erstellt bis",
          "member": "Mitglied",
          "members": {
            "search": "Benutzername oder Spitzname",
            "role": "Rolle",
            "state": "Status",
            "acceptedAtGt": "Beigetreten ab",
            "acceptedAtLt": "Beigetreten bis",
            "invitedAtGt": "Eingeladen ab",
            "invitedAtLt": "Eingeladen bis",
            "requestedAtGt": "Angefragt ab",
            "requestedAtLt": "Angefragt bis",
            "declinedAtGt": "Abgelehnt ab",
            "declinedAtLt": "Abgelehnt bis",
            "inactiveSince": "Inaktiv seit",
            "verified": "RSI-Organisation",
            "verifiedYes": "Verifiziert",
            "verifiedNo": "Nicht verifiziert",
            "withoutRsiHandle": "Kein RSI-Handle",
            "withoutDiscord": "Kein Discord verknüpft",
            "withoutSquadron": "In keiner Staffel"
          },
          "inviteUrls": {
            "expiresAfter": "Expire after",
            "limit": "Max number of uses"
          },
          "logistics": {
            "search": "Artikel suchen..."
          }
        },
        "manufacturer": "Hersteller",
        "commodities": {
          "description": "Beschreibung",
          "traded": "Wird irgendwo gehandelt",
          "name": "Name",
          "commodityType": "Commodity Type",
          "uexCode": "UEX Code",
          "buyPriceGt": "Kaufpreis >=",
          "buyPriceLt": "Kaufpreis <=",
          "sellPriceGt": "Verkaufspreis >=",
          "sellPriceLt": "Verkaufspreis <=",
          "storeImageBlank": "Ohne Shop-Bild?"
        },
        "equipment": {
          "name": "Name",
          "equipmentType": "Ausrüstungstyp",
          "itemType": "Gegenstandstyp",
          "weaponClass": "Waffenklasse",
          "slot": "Platz",
          "size": "Größe",
          "grade": "Stufe",
          "buyPriceGt": "Kaufpreis >=",
          "buyPriceLt": "Kaufpreis <=",
          "sellPriceGt": "Verkaufspreis >=",
          "sellPriceLt": "Verkaufspreis <=",
          "storeImageBlank": "Ohne Shop-Bild?",
          "subType": "Untertyp"
        },
        "notifications": {
          "search": "Suchen"
        },
        "blueprints": {
          "org": "Vergeben von",
          "scKey": "Spielschlüssel",
          "withKnownSource": "Hat eine bekannte Quelle",
          "withCraftable": "Ergebnis in einem Katalog",
          "currentVersion": "Im aktuellen Build",
          "name": "Baupläne suchen",
          "craftableType": "Fertigt",
          "source": "Quelle",
          "withSource": "Mit bekannter Quelle",
          "withoutSource": "Ohne bekannte Quelle",
          "alignment": "Ausrichtung der Quelle",
          "material": "Verwendet Material",
          "ownedFilter": "Im Besitz",
          "owned": "Im Besitz",
          "notOwned": "Nicht im Besitz"
        },
        "missions": {
          "location": "Ort",
          "ship": "Dein Schiff",
          "name": "Missionen suchen",
          "org": "Angeboten von",
          "standing": "Ansehen",
          "rewarding": "Zahlt",
          "alignment": "Seite des Gesetzes",
          "kind": "Art",
          "releasedFilter": "Im Release",
          "released": "Im Release",
          "unreleased": "Nicht im Release"
        },
        "fleetDirectory": {
          "search": "Name, FID oder SID",
          "memberCountGteq": "Mindestens Mitglieder",
          "activity": "Aktivität",
          "language": "Sprache",
          "alignment": "Ausrichtung",
          "commitment": "Engagement",
          "timezone": "Zeitzone",
          "recruiting": "Nur rekrutierende",
          "roleplay": "Nur Rollenspiel"
        }
      },
      "station": {
        "docks": "Andockplätze",
        "location": "Standort",
        "type": "Typ",
        "shops": "Geschäfte",
        "locationPrefix": {
          "default": "on",
          "orbit": "in orbit around"
        }
      },
      "tradeRoutes": {
        "intro": "Der beste einzelne Flug zwischen zwei Terminals für dein Schiff, dein Budget und so aktuelle Preise, wie du willst. Die Preise stammen von UEX und werden stündlich aktualisiert.",
        "yourRun": "Dein Flug",
        "ship": "Schiff",
        "noShip": "Wähle ein Schiff, um nach dem Gewinn pro Flug zu sortieren",
        "noShipShort": "Kein Schiff",
        "scu": "%{count} SCU",
        "budget": "Budget",
        "budgetPlaceholder": "Optional",
        "buyIn": "Kaufen in",
        "anySystem": "Alle",
        "commodity": "Ware",
        "allCommodities": "Alle Waren",
        "priceAge": "Preise nicht älter als",
        "priceAges": {
          "day": "24 Std.",
          "threeDays": "3 Tage",
          "any": "Alle"
        },
        "bestRun": "Bester Flug",
        "buyAt": "Kaufen bei",
        "sellAt": "Verkaufen bei",
        "pricePerScu": "%{price} aUEC / SCU",
        "distanceValue": "%{count} Gm",
        "jumpTo": "Sprung nach %{system}",
        "pricesFrom": "Preise von %{time}",
        "otherBuyers": {
          "one": "+%{count} weiterer Abnehmer",
          "other": "+%{count} weitere Abnehmer"
        },
        "profitThisRun": "Gewinn pro Flug",
        "profitPerScu": "Gewinn pro SCU",
        "aUecPerScu": "aUEC · %{value} pro SCU",
        "load": "Ladung",
        "loadOf": "%{load} von %{cargo} SCU",
        "thisShip": "Dieses Schiff",
        "unflyable": {
          "origin": "%{ship} kann bei %{terminal} nicht landen",
          "destination": "%{ship} kann bei %{terminal} nicht landen",
          "both": "%{ship} kann an keinem Ende landen"
        },
        "loadLimits": {
          "hold": "Frachtraum voll",
          "stock": "Begrenzt durch Vorrat",
          "demand": "Begrenzt durch Nachfrage",
          "budget": "Begrenzt durch Budget"
        },
        "youSpend": "Du gibst aus",
        "pickShipForRun": "Wähle ein Schiff, um den Gewinn pro Flug zu sehen.",
        "moreRuns": "Weitere Flüge",
        "runs": "Flüge",
        "rankBy": "Sortieren nach",
        "profitPerRun": "Gewinn pro Flug",
        "profitPerDistance": "Gewinn pro Gm",
        "shortest": "Kürzeste",
        "buySell": "Kauf → Verkauf",
        "spend": "Einsatz",
        "distance": "Entfernung",
        "prices": "Preise",
        "profit": "Gewinn",
        "to": "nach",
        "everyBuyer": "Alle Abnehmer für %{commodity} von %{terminal}",
        "empty": "Keine passenden Flüge. Versuche ältere Preise oder ein anderes System.",
        "loadExplained": "Die Ladung nutzt die Kistengrößen, die beide Terminals und die Ware erlauben, begrenzt durch den Vorrat beim Kauf, die Nachfrage beim Verkauf und dein Budget.",
        "poweredByUex": "Preise von UEX"
      },
      "hardpoints": {
        "prefix": "Konfigurationen testen mit",
        "erkul": "Erkul's DPS Calculator",
        "spviewer": "SP Viewer",
        "spviewerTitle": "SC Ships Performances Viewer",
        "metricsCredit": "Werte basieren auf den Formeln von"
      },
      "scunpacked": {
        "prefix": "Loadouts based on Gamefiles powered by",
        "link": "SCunpacked"
      },
      "newVehicle": {
        "nullablePrompt": "Schiff auswählen"
      },
      "table": {
        "selected": "%{count} ausgewählt",
        "selectRow": "Zeile auswählen",
        "selectAll": "Alle Zeilen auswählen"
      },
      "commodityPrice": {
        "item": "ShopCommodity",
        "price": "Preis",
        "type": "Typ",
        "shop": "Geschäft"
      },
      "hangarPledgeItems": {
        "openOnRsi": "Im RSI-Hangar öffnen",
        "flair": "Hangar-Flair",
        "upgrades": "Upgrades / CCUs",
        "equipment": "FPS-Ausrüstung",
        "createdOn": "Erstellt",
        "meltable": "Einschmelzbar",
        "withValue": "Mit Einschmelzwert",
        "paints": "Lackierungen",
        "pledge": "Pledge %{id}",
        "meltValue": "Einschmelzwert",
        "partOf": "Teil von %{name}",
        "pledgeValue": "Pledge-Wert",
        "quantity": "Anzahl",
        "search": "Nach Namen suchen",
        "shipComponents": "Schiffskomponenten",
        "addToInventory": "Zum Inventar hinzufügen",
        "inventory": "Inventar",
        "inInventory": "In %{name}",
        "select": "Auswählen",
        "andMore": {
          "one": "und %{count} weiterer",
          "other": "und %{count} weitere"
        }
      },
      "buybacks": {
        "name": "Rückkauf-Pledges",
        "search": "Rückkauf-Pledges durchsuchen",
        "kind": "Art",
        "kinds": {
          "package": "Paket",
          "ship": "Einzelschiff",
          "upgrade": "Upgrade",
          "paint": "Lackierung",
          "addon": "Add-on",
          "other": "Sonstiges"
        },
        "upgraded": "Aufgewertet",
        "reclaimedOn": "Eingeschmolzen",
        "notAvailable": "Nicht verfügbar",
        "price": "Preis",
        "insurance": "Versicherung",
        "lifetimeInsurance": "LTI",
        "noInsurance": "Keine Versicherung",
        "insuranceMonths": {
          "one": "%{count} Monat",
          "other": "%{count} Monate"
        },
        "openOnRsi": "Auf RSI zurückkaufen",
        "remove": "Entfernen",
        "priceRange": "Preisbereich",
        "priceMin": "Mindestpreis (USD)",
        "priceMax": "Höchstpreis (USD)",
        "upgradeFrom": "Upgrade von",
        "upgradeTo": "Upgrade auf",
        "gets": "Bringt dir das Schiff"
      },
      "buybackSync": {
        "extensionVersion": "Installierte Erweiterungsversion",
        "detailsProgress": "Rückkaufpreise werden gelesen",
        "pages": "Seiten",
        "added": "Neu",
        "removed": "Entfernt",
        "prices": "Preise gelesen",
        "background": {
          "finished": "Rückkauf-Synchronisierung abgeschlossen",
          "incomplete": "Rückkauf-Synchronisierung abgeschlossen, einige Preise fehlen",
          "unsupported": "Rückkauf-Synchronisierung braucht eine neuere Erweiterung",
          "failed": "Rückkauf-Synchronisierung fehlgeschlagen"
        },
        "status": {
          "fetching": "Rückkaufseiten werden gelesen",
          "submitting": "Wird gespeichert",
          "finished": "Abgeschlossen",
          "unsupported": "Nicht unterstützt",
          "failed": "Fehlgeschlagen"
        },
        "stepDetails": {
          "saved": "Neu: %{added} · Entfernt: %{removed}",
          "prices": "%{done} von %{total}",
          "pricesPending": "Für die seit der letzten Synchronisierung neuen Pledges",
          "read": "Gelesene Seiten: %{page} · Rückkauf-Pledges: %{count}"
        },
        "firstSyncTitle": "Die erste Synchronisierung dauert länger",
        "updateExtensionTitle": "Sync-Erweiterung aktualisieren",
        "finishedTitle": "Rückkauf-Pledges synchronisiert",
        "runningTitle": "Rückkauf-Pledges werden synchronisiert",
        "pledges": "Rückkauf-Pledges"
      },
      "syncExtension": {
        "warnings": "Warnungen",
        "backgroundProgress": "Hangar wird synchronisiert",
        "backgroundFinished": "Hangar-Synchronisierung abgeschlossen",
        "backgroundFailed": "Hangar-Synchronisierung fehlgeschlagen",
        "backgroundCancelled": "Hangar-Synchronisierung abgebrochen",
        "status": {
          "failed": "Import fehlgeschlagen!",
          "cancelled": "Import abgebrochen"
        },
        "processSteps": {
          "fetchHangar": "Dein RSI-Hangar wird gelesen",
          "submitData": "Speichern auf Fleetyards"
        },
        "signedInAs": "Bei RSI angemeldet als %{handle}",
        "signInToRsi": "Bei RSI anmelden",
        "checkIdentity": "RSI-Sitzung prüfen",
        "targetGroup": "Gruppe für die gefundenen Schiffe",
        "addBundledVehicles": "Mitgelieferte Snub Crafts hinzufügen",
        "addBundledVehiclesHint": "Fügt den Snub Craft hinzu, der zu einem Schiff gehört. Bereits vorhandene bleiben in jedem Fall erhalten.",
        "syncPaints": "Lackierungen synchronisieren",
        "syncPaintsHint": "Ersetzt deine Lackierungen durch die aus deinem RSI-Hangar. Aus lässt die gespeicherten Lackierungen unverändert.",
        "syncHangarFlair": "Hangar-Flair synchronisieren",
        "syncHangarFlairHint": "Ersetzt dein Hangar-Flair durch das aus deinem RSI-Hangar. Aus lässt das gespeicherte Flair unverändert.",
        "syncCcus": "CCUs synchronisieren",
        "syncCcusHint": "Ersetzt deine CCUs durch die aus deinem RSI-Hangar. Aus lässt die gespeicherten CCUs unverändert.",
        "syncEquipment": "FPS-Ausrüstung synchronisieren",
        "syncEquipmentHint": "Ersetzt deine FPS-Ausrüstung durch die aus deinem RSI-Hangar. Aus lässt die gespeicherte Ausrüstung unverändert.",
        "settings": "Einstellungen",
        "unmatchedVehiclesAction": "Schiffe, die nicht im RSI-Hangar sind",
        "unmatchedVehiclesActionHint": "Was mit Schiffen passiert, die hier stehen, die der Sync aber nicht in deiner RSI-Pledge-Liste findet.",
        "unmatchedHangarGroup": "Gruppe, in die sie einsortiert werden",
        "unmatchedHangarGroupHint": "Die Schiffe bleiben unverändert, sie werden nur in dieser Gruppe gesammelt, damit du sie in Ruhe durchgehen kannst.",
        "unmatchedVehiclesActions": {
          "wishlist": "Auf die Wunschliste verschieben",
          "delete": "Löschen",
          "keep": "Unverändert lassen",
          "group": "In eine Gruppe einsortieren"
        },
        "identityStatus": {
          "pending": "Prüfe...",
          "notFound": "nicht gefunden",
          "connected": "verbunden"
        },
        "platforms": {
          "chrome": "Google Chrome",
          "firefox": "Mozilla Firefox",
          "edge": "Microsoft Edge",
          "opera": "Opera",
          "github": "GitHub"
        },
        "pledgeItems": {
          "pages": "Seiten",
          "paints": "Lackierungen",
          "hangarFlair": "Hangar-Flair",
          "paintsNotSynced": "Lackierungen (nicht synchronisiert)",
          "hangarFlairNotSynced": "Hangar-Flair (nicht synchronisiert)",
          "equipment": "FPS-Ausrüstung",
          "ccus": "Upgrades / CCUs",
          "ccusNotSynced": "CCUs (nicht synchronisiert)",
          "equipmentNotSynced": "FPS-Ausrüstung (nicht synchronisiert)",
          "extras": "Sonstiges",
          "shipComponents": "Schiffskomponenten",
          "shipComponentsNotSynced": "Schiffskomponenten (nicht synchronisiert)"
        },
        "importedItems": {
          "importedVehicles": "Hinzugefügte Schiffe",
          "foundVehicles": "Gefundene Schiffe",
          "movedVehiclesToWanted": "Schiffe auf Wunschliste verschoben",
          "deletedVehicles": "Gelöschte Schiffe",
          "groupedVehicles": "In eine Gruppe einsortierte Schiffe",
          "unchangedVehicles": "Unverändert gelassene Schiffe",
          "missingModels": "Schiffe nicht gefunden",
          "importedComponents": "Hinzugefügte Komponenten",
          "foundComponents": "Gefundene Komponenten",
          "missingComponents": "Komponenten nicht gefunden",
          "missingComponentVehicles": "Kein passendes Schiff für Komponenten gefunden",
          "importedUpgrades": "Hinzugefügte Upgrades",
          "foundUpgrades": "Gefundene Upgrades",
          "syncedPaints": "Synchronisierte Lackierungen",
          "syncedHangarFlair": "Synchronisiertes Hangar-Flair",
          "syncedCcus": "Synchronisierte CCUs",
          "syncedEquipment": "Synchronisierte FPS-Ausrüstung",
          "missingUpgrades": "Upgrades nicht gefunden",
          "missingUpgradeVehicles": "Kein passendes Schiff für Upgrades gefunden"
        },
        "incomplete": "Einige Gegenstände in deinem RSI-Hangar konnten nicht gelesen werden, daher wurden fehlende Schiffe dieses Mal unverändert gelassen.",
        "stepDetails": {
          "read": "Gelesene Seiten: %{pages} · Pledges: %{count}",
          "saving": "Deine Pledges werden deinem Hangar zugeordnet …",
          "page": "Seite %{page}",
          "pageOf": "Seite %{page} von %{total}",
          "sending": {
            "one": "%{count} Eintrag wird gesendet",
            "other": "%{count} Einträge werden gesendet"
          },
          "sent": {
            "one": "%{count} Eintrag gesendet",
            "other": "%{count} Einträge gesendet"
          },
          "pageOfAbout": "Seite %{page} von etwa %{total}"
        },
        "unmatchedCount": {
          "one": "1 Eintrag konnte nicht zugeordnet werden",
          "other": "%{count} Einträge konnten nicht zugeordnet werden"
        },
        "unmatchedHeading": "Nicht zugeordnet",
        "failedStep": {
          "fetchHangar": "Dein RSI-Hangar konnte nicht gelesen werden",
          "submitData": "Speichern auf Fleetyards fehlgeschlagen"
        },
        "whatToSync": "Was synchronisiert wird",
        "unmatchedActionLabel": "Was mit ihnen passiert",
        "notSyncing": "Wird nicht synchronisiert",
        "targetGroupHint": "Jedes Schiff, das die Synchronisierung findet oder hinzufügt, kommt in diese Gruppe, zusätzlich zu seinen bisherigen Gruppen.",
        "extensionNeededTitle": "Sync-Erweiterung hinzufügen",
        "finishedTitle": "Hangar synchronisiert",
        "failedTitle": "Die Synchronisierung wurde nicht abgeschlossen",
        "savedAsYouChange": "Wird beim Ändern gespeichert",
        "resultKinds": {
          "ships": "Schiffe",
          "components": "Module",
          "upgrades": "Upgrades",
          "paints": "Lackierungen",
          "hangarFlair": "Hangar-Flair",
          "equipment": "FPS-Ausrüstung",
          "ccus": "CCUs",
          "shipComponents": "Schiffskomponenten"
        },
        "newCount": {
          "one": "+1 neu",
          "other": "+%{count} neu"
        },
        "resultActions": {
          "movedVehiclesToWanted": "Auf die Wunschliste verschoben",
          "deletedVehicles": "Gelöscht",
          "groupedVehicles": "In eine Gruppe einsortiert",
          "unchangedVehicles": "Unverändert gelassen"
        },
        "nothingChangedTitle": "Nichts geändert",
        "stepStatus": {
          "pending": "Noch nicht begonnen",
          "active": "Läuft",
          "done": "Erledigt",
          "failed": "Fehlgeschlagen",
          "warning": "Mit Warnungen abgeschlossen"
        },
        "lastSync": {
          "of": "von %{count}",
          "ofLong": "%{count} beim letzten Sync",
          "more": "%{count} mehr als beim letzten Sync",
          "fewer": "%{count} weniger als beim letzten Sync",
          "same": "Genauso viele wie beim letzten Sync",
          "reading": "%{count} von etwa %{total} Einträgen"
        },
        "viewImport": "Import dieses Syncs ansehen",
        "lastSynced": "Zuletzt synchronisiert",
        "syncShipComponents": "Schiffskomponenten synchronisieren",
        "syncShipComponentsHint": "Ersetzt deine Schiffskomponenten (Kühler, Kraftwerke, Waffen, …) durch die aus deinem RSI-Hangar. Aus lässt die gespeicherten Schiffskomponenten unverändert."
      },
      "cargoGridViewer": {
        "capacity": "Kapazität",
        "maxContainerSize": "Max. Container",
        "packed": "Gepackt",
        "totalCargo": "Gesamtfracht",
        "didNotFit": "Passte nicht",
        "enoughShips": "Vier Schiffe füllen das Raster.",
        "addShip": "Schiff hinzufügen",
        "removeShip": "Entfernen",
        "autoFillShip": "Auto-Fill"
      },
      "travelTimes": {
        "quantumDrive": "Quantum-Antrieb",
        "fuelUsage": "Treibstoffverbrauch",
        "travelTime": "Reisezeit",
        "poweredBy": "basiert auf",
        "rank": "#",
        "size": "Größe",
        "grade": "Grade",
        "sizeValue": "S%{size}",
        "intro": "Wie lange jeder Quantum-Antrieb für deinen Sprung braucht — und wie viel Quantum-Treibstoff er dabei verbraucht.",
        "jumpDistance": "Sprungdistanz",
        "distanceHint": "1 Mkm ist eine Million Kilometer. Quer durch Stanton sind es etwa 40.",
        "filters": "Filter",
        "resetFilters": "Zurücksetzen",
        "barLegend": "Balken zeigt die Zeit im Verhältnis zum langsamsten Antrieb",
        "count": "%{count} Antriebe",
        "countFiltered": "%{count} von %{total} Antrieben",
        "noMatch": "Kein Antrieb passt zu diesen Filtern.",
        "presets": {
          "moon": "Mond-Distanz",
          "short": "Kurzer Sprung",
          "system": "Stanton quer",
          "far": "Weite Strecke"
        }
      },
      "admin": {
        "importLoaders": {
          "ship_matrix_all": {
            "name": "Alles",
            "description": "Schiffe, Module, Lackierungen, Leihschiffe und Schiffspreise auf einmal."
          },
          "ship_matrix": {
            "name": "Schiffe",
            "description": "Alle Schiffe mit Daten und Shop-Infos aus der RSI Ship Matrix."
          },
          "modules": {
            "name": "Module",
            "description": "Schiffsmodule aus dem RSI Pledge Store."
          },
          "paints": {
            "name": "Lackierungen",
            "description": "Lackierungen aus dem RSI Pledge Store."
          },
          "loaners": {
            "name": "Leihschiffe",
            "description": "Welche Leihschiffe zu jedem Schiff gehören, von RSI."
          },
          "uex_vehicle_prices": {
            "name": "Schiffspreise",
            "description": "Wo Schiffe im Spiel gekauft und gemietet werden, von UEX."
          },
          "sc_data": {
            "name": "Spieldaten · %{environment}",
            "description": "Alle Kataloge aus den ausgelesenen Spieldateien: Komponenten, Ausrüstung, Rohstoffe, Baupläne, Missionen und Orte."
          },
          "sc_data_models": {
            "name": "Schiffe aus den Spieldateien",
            "description": "Nur die Schiffe, aus dem Standard-Build."
          },
          "uex_commodity_prices": {
            "name": "Rohstoffpreise",
            "description": "Terminalpreise und Bestände, von UEX."
          },
          "uex_component_prices": {
            "name": "Komponentenpreise",
            "description": "Wo Komponenten verkauft werden, von UEX."
          },
          "uex_equipment_prices": {
            "name": "Ausrüstungspreise",
            "description": "Wo Ausrüstung verkauft wird, von UEX."
          },
          "uex_trade_routes": {
            "name": "Terminals und Handelsrouten",
            "description": "Die Terminals von UEX und die Handelsrouten zwischen ihnen."
          },
          "environments": {
            "live": "Live",
            "ptu": "PTU"
          }
        },
        "locations": {
          "parent": "Übergeordnet",
          "system": "System",
          "scKey": "Spiel-Schlüssel",
          "scRefs": "Spiel-Referenzen",
          "slug": "Slug",
          "gameType": "Spieltyp",
          "build": "Build",
          "children": "Orte darin",
          "missions": "Verknüpfte Missionen",
          "missionTemplates": "Missionsvorlagen",
          "shownWithParentOnly": "Nur mit übergeordnetem Ort sichtbar",
          "yes": "Ja",
          "no": "Nein",
          "unavailable": "nicht verfügbar",
          "appearance": "Darstellung",
          "image": "Bild",
          "color": "Farbe",
          "appearanceHint": "Die Farbe füllt den Kreis des Planeten oder Mondes, schattiert wie eine beleuchtete Kugel. Bleibt sie leer, wird sie beim Hochladen eines Bildes aus diesem übernommen.",
          "headerImageHint": "Das Bild wird als Kopfbild auf der Seite des Ortes gezeigt.",
          "shops": "Läden",
          "shopImageHint": "Das Bild wird als Kopfbild auf der Seite des Ladens gezeigt.",
          "sunHint": "Die Farbe tönt das Leuchten des Sterns."
        },
        "blueprints": {
          "status": {
            "sourceKnown": "Quelle bekannt",
            "outputResolved": "Ergebnis in einem Katalog"
          },
          "columns": {
            "source": "Quelle",
            "output": "Ergebnis",
            "build": "Build",
            "created": "Erstellt am",
            "slot": "Platz",
            "material": "Material",
            "type": "Typ",
            "quantity": "Menge",
            "minQuality": "Mindestqualität",
            "stat": "Wert",
            "change": "Änderung",
            "base": "Basis",
            "ramp": "Verlauf",
            "kind": "Art",
            "org": "Org",
            "mission": "Mission",
            "standing": "Ansehen",
            "pool": "Pool"
          },
          "makes": "Fertigt",
          "noOutput": "In keinem Katalog",
          "slug": "Slug",
          "scKey": "Spielschlüssel",
          "scRef": "Spielreferenz",
          "build": "Build",
          "state": "Status",
          "states": {
            "current": "Aktuell",
            "retired": "Ausgemustert"
          },
          "createdAt": "Erstellt am",
          "updatedAt": "Aktualisiert am"
        },
        "missions": {
          "unnamed": "Vom Spiel nie benannt",
          "slug": "Slug",
          "scKey": "Spiel-Key",
          "scRef": "Spiel-Ref",
          "generator": "Generator",
          "debugName": "Debug-Name",
          "build": "Build",
          "difficultyAxes": "Schwierigkeit (Können / Last / Risiko / Wissen)",
          "state": "Status",
          "states": {
            "retired": "Entfernt",
            "released": "Im Release",
            "unreleased": "Nicht im Release"
          },
          "columns": {
            "released": "Im Release",
            "generator": "Generator",
            "build": "Build",
            "rewardKind": "Art",
            "amount": "Betrag",
            "rewardDetail": "Detail"
          },
          "filters": {
            "debugName": "Debug-Name",
            "named": "Benannt",
            "unnamed": "Nie benannt",
            "namedFilter": "Benennung",
            "currentBuild": "Nur aktueller Build",
            "anyBuild": "Beliebiger Build",
            "build": "Build"
          }
        },
        "dashboard": {
          "quickStats": {
            "onlineUsers": "Online-Benutzer"
          }
        },
        "supporterContributions": {
          "source": {
            "patreon": "Patreon",
            "kofi": "Ko-fi",
            "buymeacoffee": "Buy me a coffee",
            "paypal": "PayPal",
            "other": "Sonstige"
          },
          "linkedVia": {
            "patreon_account": "Patreon-Konto",
            "claim_key": "Unterstützer-Token",
            "payer_email": "E-Mail des Zahlenden",
            "manual": "Von einem Admin gesetzt"
          }
        },
        "announcements": {
          "columns": {
            "title": "Titel",
            "status": "Status",
            "deliveries": "Kanäle",
            "recipients": "Empfänger",
            "publishedAt": "Gesendet"
          },
          "statuses": {
            "draft": "Entwurf",
            "scheduled": "Geplant",
            "publishing": "Wird gesendet",
            "published": "Gesendet",
            "failed": "Fehlgeschlagen"
          },
          "channels": {
            "in_app": "In-App",
            "discord": "Discord",
            "bluesky": "Bluesky"
          },
          "deliveryStatuses": {
            "pending": "Ausstehend",
            "succeeded": "Gesendet",
            "skipped": "Übersprungen",
            "failed": "Fehlgeschlagen"
          },
          "lastTested": "Zuletzt getestet %{time}",
          "noChannel": "Wähle mindestens einen Kanal.",
          "notifyUsersInfo": "E-Mail nur bei aktivierter Option.",
          "discordPartsInfo": "Leer: wird automatisch aufgeteilt.",
          "socialPartsInfo": "Leer: ein gekürzter Post. Ab zwei: ein Thread.",
          "recipientsCount": "%{count} Empfänger",
          "partPosition": "%{position} von %{total}",
          "deliverySummary": "%{sent}/%{total} gesendet",
          "deliveryFailedCount": "%{count} fehlgeschlagen",
          "deliveryPendingCount": "%{count} ausstehend",
          "deliverySkippedCount": "%{count} übersprungen",
          "attempts": "%{count} Versuche",
          "content": "Inhalt",
          "manualPostsInfo": "Der Text, den Bluesky bekommt, zum Posten von Hand auf X oder anderswo.",
          "engagement": {
            "likes": "Likes",
            "reposts": "Reposts",
            "replies": "Antworten",
            "quotes": "Zitate",
            "noReactions": "Noch keine Reaktionen.",
            "fetchedAt": "Aktualisiert %{time}",
            "notFetched": "Die Zahlen kommen innerhalb einer Stunde.",
            "untracked": "Gesendet, bevor Reaktionen erfasst wurden."
          }
        },
        "resourceAccess": {
          "title": "Ressourcenzugriff",
          "groups": {
            "ship_data": "Schiffsdaten",
            "community": "Community",
            "system": "System"
          },
          "privileges": {
            "locations": "Orte",
            "blueprints": "Baupläne",
            "models": "Modelle",
            "model_modules": "Modell-Module",
            "components": "Komponenten",
            "manufacturers": "Hersteller",
            "vehicles": "Fahrzeuge",
            "images": "Bilder",
            "fleets": "Flotten",
            "users": "Benutzer",
            "supporters": "Unterstützer",
            "admins": "Admins",
            "announcements": "Ankündigungen",
            "game_events": "Spiel-Events",
            "homepage": "Startseite",
            "oauth_applications": "OAuth-Anwendungen",
            "maintenance": "Wartung",
            "imports": "Importe",
            "features": "Features",
            "workers": "Worker",
            "pghero": "PgHero",
            "rsi-api-status": "RSI-API-Status",
            "stats": "Statistiken"
          }
        },
        "versions": {
          "blank": "leer",
          "revertQuestion": "Zurücksetzen?",
          "sources": {
            "custom": "Admin",
            "rsi_loader": "Ship Matrix",
            "sc_data_loader": "Spieldateien",
            "sc_loader": "Spieldateien",
            "uex_price_sync": "UEX-Preisabgleich",
            "unknown": "Unbekannt"
          }
        },
        "models": {
          "unlisted": "Ohne Model"
        }
      },
      "hangarTable": {
        "extraColumns": "Spalten",
        "columns": {
          "storeImage": "Bild",
          "storeImageWide": "Breites Bild",
          "angledView": "3D-Bild",
          "angledViewWide": "Breites 3D-Bild",
          "modelManufacturerName": "Hersteller",
          "modelLength": "Länge",
          "modelBeam": "Breite",
          "modelHeight": "Höhe",
          "modelMass": "Masse",
          "modelCargo": "Fracht",
          "modelCrew": "Besatzung",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "Max. Geschwindigkeit",
          "modelGroundMaxSpeed": "Bodengeschwindigkeit",
          "modelFocus": "Fokus",
          "modelProductionStatus": "Produktionsstatus",
          "modelPrice": "Preis",
          "modelPledgePrice": "Pledge-Preis"
        }
      },
      "fleetTable": {
        "extraColumns": "Spalten",
        "columns": {
          "storeImage": "Bild",
          "storeImageWide": "Breites Bild",
          "angledView": "3D Bild",
          "angledViewWide": "Breites 3D Bild",
          "modelManufacturerName": "Hersteller",
          "modelLength": "Länge",
          "modelBeam": "Breite",
          "modelHeight": "Höhe",
          "modelMass": "Masse",
          "modelCargo": "Fracht",
          "modelCrew": "Besatzung",
          "modelScmSpeed": "SCM Geschwindigkeit",
          "modelMaxSpeed": "Max Geschwindigkeit",
          "modelGroundMaxSpeed": "Bodengeschwindigkeit",
          "modelProductionStatus": "Produktionsstatus",
          "modelPrice": "Preis",
          "modelPledgePrice": "Pledge Preis",
          "owner": "Besitzer",
          "vehiclesCount": "Anzahl"
        }
      },
      "logistics": {
        "inventoryCount": "inventories",
        "pending": "pending",
        "entriesCount": "entries",
        "managedBy": "Managed by",
        "itemName": "Name",
        "category": "Category",
        "componentCategory": "Komponententyp",
        "commodityType": "Warentyp",
        "equipmentItemType": "Ausrüstungstyp",
        "crafted": {
          "request": "Hergestelltes Teil anfordern",
          "page": "Hergestellt aus %{recipe} mit den Qualitäten %{grades}. Hervorgehobene Werte weichen vom Katalog ab.",
          "showStock": "Serienwerte anzeigen",
          "edit": "Festhalten, wie es hergestellt wurde",
          "summary": "Hergestellt %{grades}",
          "lot": "Hergestellt",
          "grade": "Q %{quality}",
          "slotGrade": "Slot %{position}: %{quality}"
        },
        "itemPicker": {
          "field": "Gegenstand",
          "placeholder": "Gegenstand wählen",
          "custom": "„%{name}“ als eigenen Gegenstand hinzufügen",
          "search": "Nach Namen suchen",
          "chooseCategory": "Wähle eine Kategorie, um ihre Gegenstände zu durchsuchen.",
          "results": {
            "one": "%{count} Gegenstand",
            "other": "%{count} Gegenstände"
          },
          "noResults": "Keine Gegenstände passen zu diesen Filtern.",
          "clear": "Katalogeintrag entfernen",
          "capacity": "Kapazität"
        },
        "quantity": "Quantity",
        "unit": "Unit",
        "notes": "Notes",
        "status": "Status",
        "requested": "Requested",
        "description": "Description",
        "priority": "Priority",
        "requestedBy": "Requested by",
        "states": {
          "draft": "Draft",
          "submitted": "Submitted",
          "rejected": "Rejected",
          "cancelled": "Cancelled"
        },
        "requestTypes": {
          "general": "General"
        },
        "priorities": {
          "standard": "Standard",
          "critical": "Critical"
        },
        "searchItems": "Search items...",
        "quality": "Quality (0-1000)",
        "qualityShort": "Q %{quality}",
        "qualityMin": "Quality >=",
        "qualityMax": "Quality <=",
        "existingItem": "Select existing item",
        "inventoryName": "Inventory Name",
        "visibility": "Visibility",
        "visibilities": {
          "members_only": "All Members",
          "officers_only": "Officers Only",
          "squadron_only": "Nur eine Staffel"
        },
        "inventory": "Inventory",
        "notesPlaceholder": "Add notes...",
        "entryType": "Type",
        "entryTypes": {
          "deposit": "Deposit",
          "withdrawal": "Withdrawal"
        },
        "stockView": "Current Stock",
        "logView": "Transaction Log",
        "addedBy": "Logged by",
        "member": "Member",
        "selectItem": "Select item",
        "currentStock": "Available",
        "location": "Location",
        "image": "Image",
        "categories": {
          "commodity": "Commodity",
          "component": "Component",
          "weapon": "Weapon",
          "equipment": "Equipment",
          "ammunition": "Attachments & Ammunition",
          "consumable": "Consumable",
          "other": "Other"
        },
        "units": {
          "scu": "SCU",
          "units": "Units"
        },
        "csvImportHelp": "Upload a CSV file with columns: name, category, quantity, unit, notes. Download the template for the correct format.",
        "imported": "items imported",
        "importErrors": "errors",
        "inStock": "In stock",
        "entries": "Entries",
        "lastEntry": "Last entry",
        "history": "History",
        "lots": "Chargen",
        "linkedItem": "Linked item",
        "catalogueIdentity": "Name und Kategorie stammen vom verknüpften Katalogeintrag.",
        "itemUnavailable": "Not in current patch",
        "itemUnavailableHint": "The current game build no longer ships this item. Entries keep it, but it cannot be picked for new ones.",
        "openInCatalogue": "Im Katalog öffnen",
        "qualityRange": "Quality",
        "stockItem": "Stock Item",
        "overCapacity": "über der Frachtkapazität",
        "cargoGrid": "Frachtraster",
        "shipInventory": "Schiffsinventar",
        "remaining": "Verbleibend",
        "unmeasured": "%{count} noch nicht vermessen",
        "transferTarget": "Empfänger",
        "transferNote": "Notiz",
        "noStock": "Nichts zu verschieben",
        "overStock": "Mehr als diese Position enthält",
        "incoming": "Eingehend",
        "outgoing": "Ausgehend",
        "transferStates": {
          "pending": "Wartet",
          "completed": "Zugestellt",
          "declined": "Abgelehnt",
          "cancelled": "Zurückgezogen",
          "expired": "Abgelaufen"
        },
        "acceptInto": "Annehmen in",
        "reportReason": "Grund",
        "reportReasons": {
          "spam": "Spam",
          "harassment": "Belästigung",
          "scam": "Betrug",
          "other": "Etwas anderes"
        },
        "transferToFleet": "%{fleet} (Flotte)",
        "sender": "Von",
        "recipient": "An",
        "contents": "Inhalt",
        "state": "Status",
        "sentAt": "Gesendet",
        "transferKinds": {
          "inventory": "Meine Inventare",
          "fleet": "Eine Flotte",
          "user": "Eine Person",
          "mine": "Meine Inventare",
          "fleetInventories": "Diese Flotte",
          "contract": "Ein Auftrag, an dem ich arbeite"
        },
        "transferTargetKind": "Senden an",
        "contractDeliveryTarget": "%{contract} (%{fleet}): %{destination}",
        "transferFromFleet": "Aus Flotte",
        "noTransferTargets": "Hier gibt es kein Ziel",
        "recordedAt": "Erfasst",
        "origin": "Von / An",
        "inTransitAmount": "%{amount} unterwegs",
        "inTransitHint": "Auf einem Transfer, den noch niemand beantwortet hat. Bereits aus den Summen heraus.",
        "transferFromFriends": "Meine Freunde",
        "towardsContract": "Für einen Auftrag",
        "noContract": "Kein Auftrag",
        "forContract": "für"
      },
      "hangarInventories": "Inventare",
      "hangarBlueprints": {
        "owned": "Vorhanden",
        "wanted": "Gewünscht",
        "missions": "Missionen"
      },
      "adminNotifications": {
        "inbox": "Posteingang",
        "archive": "Archiv",
        "unreadOnly": "Nur ungelesene",
        "status": "Status",
        "severity": "Schweregrad",
        "type": "Typ",
        "selectPrompt": "Wähle eine Benachrichtigung, um sie zu lesen",
        "noBody": "Diese Benachrichtigung enthält keine weiteren Details.",
        "lastSeen": "Zuletzt gesehen",
        "expires": "Läuft ab",
        "severities": {
          "info": "Info",
          "warning": "Warnung",
          "error": "Fehler"
        },
        "types": {
          "paints_import": "Lackierungs-Import",
          "modules_import": "Modul-Import",
          "loaner_sync": "Leihschiff-Sync",
          "uex_prices_import": "UEX Preis-Sync",
          "uex_commodity_prices_import": "UEX Waren-Sync",
          "uex_component_prices_import": "UEX Komponenten-Sync",
          "uex_equipment_prices_import": "UEX Ausrüstungs-Sync",
          "uex_trade_routes_sync": "UEX Handelsrouten-Sync",
          "new_supporter": "Neuer Unterstützer",
          "rsi_api_blocked": "RSI-API blockiert",
          "rsi_api_unblocked": "RSI-API wiederhergestellt",
          "rsi_markup_changed": "RSI-Seite geändert",
          "weekly_stats": "Wochenbericht",
          "ship_matrix_import": "Ship-Matrix-Import",
          "sc_data_import": "sc_data-Import",
          "sc_data_unlisted_models": "Nicht gelistete Schiffe",
          "import_run": "Importieren",
          "oauth_application_review": "OAuth-App-Prüfung",
          "inventory_transfer_reports": "Gemeldete Inventar-Transfers"
        }
      },
      "optional": "optional",
      "notificationActions": {
        "open": "Öffnen",
        "openHangar": "Hangar öffnen",
        "openModel": "Schiff anzeigen",
        "openInvite": "Einladung ansehen",
        "reviewRequest": "Anfrage prüfen",
        "openMembers": "Mitglieder anzeigen",
        "openFleet": "Flotte öffnen",
        "openInventory": "Inventar öffnen",
        "openEvent": "Event öffnen",
        "openRoster": "Anmeldungen anzeigen",
        "addToCalendar": "Zum Kalender hinzufügen",
        "openStore": "Pledge Store",
        "accept": "Akzeptieren",
        "decline": "Ablehnen",
        "signUp": "Anmelden",
        "withdraw": "Abmelden",
        "syncAgain": "Erneut synchronisieren",
        "markAsBought": "Als gekauft markieren",
        "unavailable": "Das ist nicht mehr verfügbar.",
        "openTransfers": "Transfers öffnen",
        "openFriends": "Freunde öffnen",
        "openAllies": "Verbündete öffnen",
        "openTour": "Tour öffnen",
        "openSquadron": "Staffel öffnen",
        "openContract": "Auftrag öffnen",
        "openPayouts": "Auszahlung öffnen"
      },
      "notificationTypes": {
        "channels": {
          "app": "App",
          "mail": "Mail",
          "push": "Push",
          "discord": "Discord"
        },
        "groups": {
          "account": "Konto & Hangar",
          "announcements": "Ankündigungen",
          "fleetMembership": "Flottenmitgliedschaft",
          "fleetEvents": "Flotten-Events",
          "logistics": "Logistik",
          "relationships": "Freunde & Verbündete",
          "tours": "Touren",
          "fleetContracts": "Flotten-Aufträge"
        },
        "announcement": "Ankündigung",
        "hangar_sync_finished": "Hangar-Sync abgeschlossen",
        "hangar_sync_failed": "Hangar-Sync fehlgeschlagen",
        "model_on_sale": "Modell im Angebot",
        "new_model": "Neues Modell veröffentlicht",
        "fleet_invite": "Flotteneinladung erhalten",
        "fleet_member_requested": "Mitgliedschaft angefragt",
        "fleet_member_accepted": "Mitgliedschaft akzeptiert",
        "fleet_request_accepted": "Beitrittsanfrage akzeptiert",
        "fleet_joined_by_discord_role": "Über Discord-Rolle beigetreten",
        "fleet_inventory_item_added": "Flotteninventar-Eintrag hinzugefügt",
        "fleet_event_published": "Event veröffentlicht",
        "fleet_event_locked": "Event-Anmeldungen gesperrt",
        "fleet_event_starting_soon": "Event beginnt bald",
        "fleet_event_started": "Event gestartet",
        "fleet_event_completed": "Event abgeschlossen",
        "fleet_event_cancelled": "Event abgesagt",
        "fleet_event_signup_added": "Neue Anmeldung",
        "fleet_event_signup_withdrawn": "Anmeldung zurückgezogen",
        "fleet_event_signup_confirmed": "Anmeldung bestätigt",
        "fleet_event_signup_assigned": "Einem Slot zugewiesen",
        "fleet_event_signup_kicked": "Aus einem Slot entfernt",
        "allInGroup": "Alles in dieser Gruppe",
        "inventory_transfer_received": "Transfer erhalten",
        "inventory_transfer_resolved": "Transfer beantwortet",
        "friend_request_received": "Freundschaftsanfrage erhalten",
        "friend_request_accepted": "Freundschaftsanfrage angenommen",
        "fleet_ally_request_received": "Bündnisanfrage erhalten",
        "fleet_ally_request_accepted": "Bündnisanfrage angenommen",
        "tour_join_request_received": "Teilnahme-Anfrage erhalten",
        "tour_join_request_accepted": "Teilnahme-Anfrage angenommen",
        "fleet_squadron_request_received": "Staffel-Beitrittsanfrage",
        "fleet_squadron_request_accepted": "Staffel-Anfrage angenommen",
        "fleet_contract_published": "Auftrag veröffentlicht",
        "fleet_announcement_posted": "Ankündigung veröffentlicht",
        "fleet_contract_claimed": "Auftrag übernommen",
        "fleet_contract_crew_requested": "Crew möchte einem Auftrag beitreten",
        "fleet_contract_crew_answered": "Crew-Anfrage beantwortet",
        "fleet_subscription_started": "Flotten-Funktionen freigeschaltet",
        "fleet_subscription_ended": "Flotten-Funktionen verloren",
        "fleet_fid_claim_opened": "Flotten-ID beansprucht",
        "fleet_fid_claim_completed": "Flotten-ID übertragen",
        "fleet_fid_claim_cancelled": "Anspruch auf Flotten-ID beendet",
        "fleet_rsi_verification_lost": "Flottenverifizierung verloren",
        "rsi_handle_verification_lost": "RSI-Handle-Verifizierung verloren",
        "fleet_contract_fulfilled": "Auftrag erfüllt",
        "fleet_contract_settled": "Auftrag ausgezahlt",
        "payout_ledger_settled": "Auszahlung abgerechnet",
        "payout_entry_pending_review": "Ausgabe wartet auf Prüfung",
        "payout_entry_declined": "Ausgabe abgelehnt",
        "fleet_verification_requested": "Verifizierung von deiner Flotte angefragt"
      },
      "fleets": {
        "missions": {
          "untitled": "Unbenannte Mission",
          "title": "Titel",
          "description": "Beschreibung",
          "team": "Team",
          "teams": "Teams",
          "ship": "Schiff",
          "ships": "Schiffe",
          "slot": "Slot",
          "slots": "Slots",
          "noMissions": "Noch keine Missionen.",
          "noTeams": "Noch keine Teams hinzugefügt.",
          "noShips": "Noch keine Schiffe hinzugefügt.",
          "noSlots": "Noch keine Slots hinzugefügt.",
          "archivedTab": "Archiviert",
          "activeTab": "Aktiv",
          "archived": "Archiviert",
          "modelSpecific": "Bestimmtes Schiff",
          "modelList": "Eines von diesen",
          "modelListHint": "Der Platz nimmt eines der Schiffe, die du auswählst.",
          "allowedShips": "Passende Schiffe",
          "anyOf": "Eines von",
          "filterRange": "Filterbereich",
          "classification": "Klassifizierung",
          "focus": "Fokus",
          "minSize": "Min. Größe",
          "maxSize": "Max. Größe",
          "minCrew": "Min. Besatzung",
          "minCrewOverride": "Überschreiben",
          "minCrewOverrideLabel": "Min. Besatzung überschreiben",
          "minCrewOverrideHint": "Leer lassen, um die Besatzung des Schiffs zu verwenden.",
          "minCargo": "Min. Fracht (SCU)",
          "createdBy": "Erstellt von",
          "seats": "Sitze",
          "category": "Kategorie",
          "coverImage": "Titelbild",
          "scenario": "Szenario",
          "categories": {
            "other": "Sonstige",
            "ship_combat": "Schiffskampf",
            "ground_combat": "Bodenkampf",
            "combined_combat": "Kombinierter Kampf",
            "mining": "Bergbau",
            "salvage": "Bergung",
            "cargo_hauling": "Frachttransport",
            "exploration": "Erkundung"
          }
        },
        "events": {
          "untitled": "Unbenanntes Event",
          "title": "Titel",
          "description": "Beschreibung",
          "briefing": "Briefing",
          "startsAt": "Beginnt am",
          "endsAt": "Endet am",
          "timezone": "Zeitzone",
          "location": "Event-Ort",
          "meetupLocation": "Treffpunkt",
          "visibility": "Sichtbarkeit",
          "maxAttendees": "Max. Teilnehmer",
          "autoLockEnabled": "Anmeldungen automatisch sperren",
          "autoLockMinutesBefore": "Minuten vor Start sperren",
          "recurring": "Wiederholung",
          "recurringHint": "Erzeuge dieses Event automatisch nach einem wiederkehrenden Zeitplan. Mitglieder melden sich pro Termin an.",
          "recurringSummary": "Wiederholt sich %{interval}",
          "recurringUntil": "Wiederholt sich %{interval} bis %{date}",
          "recurringForCount": "Wiederholt sich %{interval} (%{count} Termine)",
          "viewSeries": "Serie anzeigen",
          "recurrenceInterval": "Wiederholen alle",
          "recurrenceEnd": "Endet",
          "recurrenceEndNever": "Nie",
          "recurrenceEndOn": "Am Datum",
          "recurrenceEndAfter": "Nach",
          "recurrenceEndOccurrences": "Terminen",
          "recurrenceUnit": {
            "daily": "Tage",
            "weekly": "Wochen",
            "monthly": "Monate"
          },
          "recurrenceWeekdays": "Am",
          "recurrenceWeekdaysHint": "Der Wochentag, an dem das Event beginnt, ist immer dabei.",
          "recurrence": {
            "daily": "täglich",
            "weekly": "wöchentlich",
            "monthly": "monatlich",
            "everyN": {
              "daily": "alle %{count} Tage",
              "weekly": "alle %{count} Wochen",
              "monthly": "alle %{count} Monate"
            },
            "onDays": "%{interval} am %{days}"
          },
          "occurrencesSection": "Anstehende Termine",
          "skipOccurrence": "Diesen Termin überspringen",
          "overrideOccurrence": "Termin am %{date} überschreiben",
          "overrideOccurrenceShort": "Diesen einen bearbeiten",
          "overrideOccurrenceHint": "Überschreibe Felder für diesen einzelnen Termin. Leer lassen, um sie vom wiederkehrenden Event zu übernehmen.",
          "endSeriesHere": "Hier und ab jetzt beenden",
          "splitSeriesHere": "Diesen und folgende bearbeiten",
          "splitSeriesConfirm": "Die Serie ab diesem Termin als neues Event fortsetzen? Anmeldungen für diesen und spätere Termine werden übernommen, und das neue Event öffnet sich zum Bearbeiten.",
          "excludedBadge": "Übersprungen",
          "noUpcomingOccurrences": "Keine anstehenden Termine in den nächsten 12 Wochen.",
          "endSeriesConfirm": "Die Wiederholung nach diesem Datum beenden? Zukünftige Termine werden nicht mehr erzeugt.",
          "skipOccurrenceSuccess": "Termin übersprungen.",
          "unskipOccurrence": "Termin wiederherstellen",
          "unskipOccurrenceSuccess": "Termin wiederhergestellt.",
          "endSeriesSuccess": "Serie ab diesem Datum beendet.",
          "cancelledReason": "Absagegrund",
          "createdBy": "Erstellt von",
          "signups": "Anmeldungen",
          "signupsCount": "%{count} Anmeldungen",
          "youAreHere": "Du bist hier",
          "attendance": "Teilnahme",
          "signupsLockedHint": "Die Anmeldungen für dieses Event sind gesperrt.",
          "alreadySignedUpHint": "Du bist bereits für einen anderen Slot angemeldet. Melde dich zuerst ab, um zu wechseln.",
          "slotTakenHint": "Dieser Slot ist bereits belegt.",
          "currentSlot": "Aktueller Slot",
          "currentSlotHint": "Das ist der Slot, in dem sich die Anmeldung aktuell befindet.",
          "takenBy": "Belegt von %{username}",
          "slotPickerHint": "Wähle einen Slot für diese Anmeldung. Bereits belegte oder nicht verfügbare Slots sind deaktiviert.",
          "signupCtaHint": "Melde dich für das Event an — du kannst jetzt einen bestimmten Slot wählen oder dich später von einem Admin zuweisen lassen.",
          "noSlotYet": "Noch kein Slot",
          "signupApproval": "Anmeldebestätigung",
          "signupStatuses": {
            "confirmed": "Bestätigt",
            "tentative": "Vorläufig",
            "interested": "Interessiert",
            "pending": "Bestätigung ausstehend",
            "withdrawn": "Zurückgezogen"
          },
          "signupApprovals": {
            "direct": "Direkt",
            "confirmation_required": "Bestätigung erforderlich"
          },
          "unassignedSignupsHint": "Diese Mitglieder haben sich für das Event angemeldet, haben aber noch keinen Slot. Weise sie unten zu oder entferne die Anmeldung.",
          "taken": "Belegt",
          "grantedRoles": "Vergebene Rollen",
          "noEventAdminsYet": "Noch keine weiteren Admins oder Moderatoren.",
          "creator": "Event-Ersteller",
          "eventTeamHint": "Gib anderen Mitgliedern Admin- oder Moderatorenrechte für dieses Event. Admins können es bearbeiten, Moderatoren können Anmeldungen verwalten.",
          "eventRole": "Rolle",
          "eventRoles": {
            "admin": "Admin",
            "moderator": "Moderator"
          },
          "memberPicker": "Mitglied",
          "spawnedEvents": "Erstellte Events",
          "fromMission": "Aus Mission",
          "pickTemplate": "Vorlage wählen",
          "pickTemplateHint": "Optional mit einer Mission starten — ihre Angaben, Teams, Schiffe und Slots werden in das Event übernommen, das mit ihr verknüpft bleibt.",
          "noTemplate": "Keine Vorlage",
          "noTemplateHint": "Das Event von Grund auf erstellen.",
          "pickTemplateLoadFailed": "Die Missionen der Flotte konnten nicht geladen werden.",
          "pickTemplatePageFailed": "Die nächsten Missionen konnten nicht geladen werden.",
          "pickTemplateSearch": "Missionen durchsuchen",
          "pickTemplateNonePublished": "Noch keine aktive Mission der Flotte ist veröffentlicht.",
          "pickTemplateNoneActive": "Die Flotte hat keine aktiven Missionen.",
          "pickTemplateNoMatch": "Keine veröffentlichte Mission passt zur Suche.",
          "changeTemplate": "Vorlage wechseln",
          "clearTemplate": "Vorlage entfernen",
          "myVehicle": "Mein Fahrzeug",
          "selectVehicle": "Fahrzeug auswählen (optional)",
          "vehicleMismatchHint": "Das ausgewählte Fahrzeug passt nicht zu den Anforderungen dieses Slots.",
          "noFittingInHangar": "In deinem Hangar passt nichts zu diesem Slot. Du kannst dich trotzdem anmelden und das Fahrzeug leer lassen.",
          "vehicleFitsHint": "Bringt ein passendes Fahrzeug mit.",
          "notes": "Notizen",
          "upcomingTab": "Anstehend",
          "pastTab": "Vergangen",
          "archivedTab": "Archiviert",
          "listTab": "Liste",
          "calendarTab": "Kalender",
          "subscribeHint": "Kopiert die URL des Kalender-Feeds in deine Zwischenablage, damit du sie in deiner Kalender-App einfügen kannst.",
          "visibilities": {
            "members": "Mitglieder",
            "officers": "Offiziere",
            "fleet": "Öffentlich",
            "squadron": "Nur eine Staffel"
          },
          "statuses": {
            "draft": "Entwurf",
            "open": "Offen für Anmeldungen",
            "locked": "Anmeldungen gesperrt",
            "active": "Live",
            "completed": "Abgeschlossen",
            "cancelled": "Abgesagt",
            "past": "Vergangen"
          },
          "tabs": {
            "basic": "Basisdaten",
            "description": "Beschreibung & Titelbild",
            "teams": "Teams & Schiffe",
            "overview": "Übersicht",
            "settings": "Einstellungen"
          },
          "calendar": {
            "month": "Monat",
            "week": "Woche",
            "weekTitle": "Woche vom %{date}"
          },
          "repeats": "Wiederholung"
        },
        "contracts": {
          "tabs": {
            "details": "Details",
            "delivery": "Lieferung",
            "crew": "Crew & Belohnung",
            "goods": "Waren"
          },
          "title": "Titel",
          "description": "Beschreibung",
          "reward": "Belohnung",
          "deadline": "Frist",
          "crewLimit": "Crew-Limit",
          "visibility": "Sichtbarkeit",
          "visibilities": {
            "members_only": "Alle Mitglieder",
            "squadron_only": "Nur eine Staffel"
          },
          "reimburseExpenses": "Auslagen erstatten",
          "from": "Abholen bei",
          "to": "Liefern an",
          "toHint": "Lieferungen in eines deiner eigenen Inventare werden an dich gesendet, und du nimmst sie selbst an.",
          "toAuthorHint": "Lieferungen gehen an %{username}, der sie annimmt.",
          "myHangarInventory": "%{name} (mein Hangar)",
          "authorHangarInventory": "%{name} (Hangar von %{username})",
          "destinationRemoved": "Nicht mehr verfügbar",
          "lead": "Leitung",
          "pendingCrew": "Wartet auf Aufnahme",
          "minQuality": "min. Qualität %{value}",
          "craftedAny": "Hergestellt, beliebige Qualität",
          "craftedAtLeast": "Hergestellt, mindestens %{grades}",
          "craftedExact": "Hergestellt, genau %{grades}",
          "pickedUp": "%{quantity} abgeholt",
          "itemCategory": "Kategorie",
          "itemUnit": "Einheit",
          "itemQuantity": "Menge",
          "kind": {
            "label": "Art",
            "transport": "Transport",
            "procurement": "Beschaffung",
            "crafting": "Herstellung"
          },
          "state": {
            "draft": "Entwurf",
            "open": "Offen",
            "in_progress": "In Arbeit",
            "fulfilled": "Erfüllt",
            "cancelled": "Abgebrochen",
            "expired": "Abgelaufen",
            "settled": "Ausgezahlt"
          },
          "itemTypes": {
            "Commodity": "Handelsware",
            "Component": "Komponente",
            "Equipment": "Ausrüstung"
          },
          "qualityMatch": "Abgleich",
          "exactQuality": "genau %{value}",
          "qualityMatches": {
            "at_least": "Mindestens",
            "exact": "Genau"
          },
          "itemQuality": "Qualität",
          "titleHint": "Optional — ohne Titel wird der Auftrag nach den geforderten Waren benannt",
          "postedBy": "Ausgeschrieben von",
          "claimedBy": "übernommen von",
          "delivered": "Geliefert",
          "deliveredOf": "%{delivered} / %{requested} %{unit}",
          "views": {
            "open": "Offen",
            "closed": "Beendet",
            "mine": "Meine",
            "completed": "Abgeschlossen"
          }
        }
      },
      "commodity": {
        "name": "Name",
        "buyPrice": "Kauf",
        "sellPrice": "Verkauf",
        "retired": "Nicht mehr im aktuellen Build",
        "containerSizes": "Containergrößen (SCU)",
        "pieceVolume": "Volumen pro Stück (SCU)",
        "consumable": "Verzehrbar",
        "refinesInto": "Wird raffiniert zu",
        "refinedFrom": "Raffiniert aus",
        "availability": {
          "retired": "Preise werden für den Build erfasst, auf dem der Katalog steht, und diese Handelsware ist nicht darin.",
          "craftedOnly": "Kein Terminal handelt damit — es ist ein Herstellungsmaterial.",
          "none": "Kein uns bekanntes Terminal kauft oder verkauft dies."
        },
        "chart": {
          "buyHighest": "Kauf, höchster",
          "buyAverage": "Kauf, Durchschnitt",
          "buyLowest": "Kauf, niedrigster",
          "sellHighest": "Verkauf, höchster",
          "sellAverage": "Verkauf, Durchschnitt",
          "sellLowest": "Verkauf, niedrigster"
        },
        "types": {
          "agricultural_supply": "Landwirtschaftsgüter",
          "alloy": "Legierungen",
          "consumer_goods": "Konsumgüter",
          "drink": "Getränke",
          "food": "Nahrungsmittel",
          "gas": "Gase",
          "hpmc": "HPMC",
          "manmade": "Künstlich",
          "medical_supply": "Medizinische Güter",
          "metal": "Metalle",
          "military_supply": "Militärgüter",
          "mineral": "Mineralien",
          "natural": "Natürlich",
          "nonmetals": "Nichtmetalle",
          "plasma_fuel": "Plasmatreibstoff",
          "processed_goods": "Verarbeitete Güter",
          "quantum_fuel": "Quantumtreibstoff",
          "rmc": "RMC",
          "scrap": "Schrott",
          "vice": "Laster",
          "waste": "Abfall"
        },
        "commodityType": "Commodity Type",
        "uexId": "UEX ID",
        "uexCode": "UEX Code",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "equipment": {
        "equipmentType": "Ausrüstungstyp",
        "itemType": "Gegenstandstyp",
        "subType": "Untertyp",
        "weaponClass": "Waffenklasse",
        "slot": "Platz",
        "size": "Größe",
        "grade": "Stufe",
        "hidden": "Hidden?",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image",
        "name": "Name",
        "manufacturer": "Hersteller",
        "retired": "Nicht mehr im aktuellen Build",
        "noMetrics": "Für diesen Gegenstand sind keine Werte hinterlegt.",
        "availability": {
          "retired": "Preise werden für den Build erfasst, auf dem der Katalog steht, und dieser Gegenstand ist nicht darin.",
          "craftedOnly": "Kein Terminal verkauft diesen Gegenstand – er wird nach dem Rezept unten hergestellt.",
          "none": "Kein Terminal kauft oder verkauft diesen Gegenstand."
        },
        "stats": {
          "damageReduction": "Schadensreduktion",
          "temperatureRating": "Temperaturbereich",
          "radiationProtection": "Strahlenschutz",
          "radiationScrubRate": "Strahlungsabbaurate",
          "gForceTolerance": "G-Kraft-Toleranz",
          "carryingCapacity": "Tragekapazität",
          "magazineSize": "Magazingröße",
          "rateOfFire": "Feuerrate",
          "range": "Effektive Reichweite",
          "weaponClass": "Waffenklasse",
          "coreCompatibility": "Kern-Kompatibilität",
          "backpackCompatibility": "Rucksack-Kompatibilität",
          "volume": "Volumen"
        },
        "sorts": {
          "damageReduction": "Schadensreduktion",
          "radiationProtection": "Strahlenschutz",
          "gForceTolerance": "G-Kraft-Toleranz",
          "rateOfFire": "Feuerrate",
          "range": "Reichweite",
          "storage": "Kapazität",
          "volume": "Volumen"
        }
      },
      "notifications": {
        "inbox": "Posteingang",
        "archive": "Archiv",
        "unreadOnly": "Nur ungelesene",
        "status": "Status",
        "type": "Typ",
        "selectPrompt": "Wähle eine Benachrichtigung, um sie zu lesen",
        "noBody": "Diese Benachrichtigung enthält keine weiteren Details.",
        "archivesOn": "Wandert ins Archiv",
        "deletesOn": "Gelöscht"
      },
      "unlistedModel": {
        "linkHint": "Welches Schiff im Katalog ist %{identifier}? Der Vorschlag stammt aus dem Export und kann falsch sein."
      },
      "slug": "Slug",
      "inventories": {
        "source": "Herkunft",
        "sources": {
          "vehicle": "Schiff",
          "handMade": "Selbst angelegt"
        }
      },
      "inventoryItems": {
        "name": "Name",
        "category": "Kategorie",
        "entryType": "Buchung",
        "quantity": "Menge",
        "quality": "Qualität",
        "notes": "Notizen",
        "itemType": "Katalog",
        "categories": {
          "commodity": "Ware",
          "component": "Komponente",
          "weapon": "Waffe",
          "equipment": "Ausrüstung",
          "ammunition": "Munition",
          "consumable": "Verbrauchsgut",
          "other": "Sonstiges"
        },
        "entryTypes": {
          "deposit": "Einlagerung",
          "withdrawal": "Entnahme"
        },
        "units": {
          "scu": "SCU",
          "units": "Stück"
        }
      },
      "shipHistory": {
        "sales": "Sale-Historie",
        "salesCount": "Aufgezeichnete Sales",
        "lastSale": "Letzter Sale",
        "averageGap": "Durchschnittlicher Abstand",
        "days": "%{count} Tage",
        "ongoing": "Läuft",
        "priceHistory": "Pledge-Preis-Historie",
        "firstPriced": "Erstmals bepreist",
        "priceRemoved": "Preis entfernt",
        "wishlist": "Wunschlisten-Zuwachs pro Monat",
        "patchChanges": "Patch-Änderungen",
        "notRecordedYet": "Wird erst seit dem Start der Aufzeichnung erfasst, ein Schiff kann also noch nichts haben."
      },
      "buildCompare": {
        "from": "Von Build",
        "to": "Zu Build",
        "appeared": "Neu",
        "vanished": "Entfallen",
        "changed": "Geändert",
        "notRecorded": "Für einen dieser Builds nicht erfasst.",
        "needsTwoBuilds": "Es ist nur ein Build erfasst, es gibt also nichts zu vergleichen.",
        "pickTwoBuilds": "Wähle zwei verschiedene Builds.",
        "failed": "Diese beiden Builds konnten nicht verglichen werden.",
        "andMore": "und %{count} weitere",
        "catalogues": {
          "components": "Komponenten",
          "equipment": "Ausrüstung",
          "commodities": "Waren",
          "models": "Schiffe"
        }
      },
      "dockAccess": {
        "ramp": "Rampe",
        "lift": "Aufzug",
        "tractor_beam": "Traktorstrahl"
      },
      "dockTypes": {
        "vehiclepad": "Fahrzeugstellplatz",
        "garage": "Garage",
        "landingpad": "Landeplatz",
        "dockingport": "Andockstutzen",
        "hangar": "Hangar",
        "cargogrid": "Frachtgitter"
      },
      "shipSizes": {
        "extra_extra_small": "Snubcraft (XXS)",
        "extra_small": "Extra klein (XS)",
        "small": "Klein (S)",
        "medium": "Mittel (M)",
        "large": "Groß (L)",
        "extra_large": "Extra groß (XL)",
        "capital": "Kapital (C)"
      },
      "payouts": {
        "currency": "Währung",
        "archived": "Archiviert",
        "activeTours": "Aktuell",
        "amount": "Betrag",
        "description": "Beschreibung",
        "entryType": "Art",
        "expense": "Ausgegeben",
        "income": "Eingenommen",
        "participant": "Wer",
        "notes": "Notizen",
        "occurredAt": "Wann",
        "paid": "Ausgegeben",
        "held": "Hält",
        "share": "Anteil",
        "net": "Saldo",
        "profit": "Gewinn",
        "totalIncome": "Eingenommen",
        "totalExpenses": "Ausgegeben",
        "guest": "Gast",
        "username": "Benutzername",
        "name": "Name",
        "sends": "sendet",
        "receives": "erhält",
        "settled": "Abgerechnet",
        "open": "Offen",
        "owes": "schuldet",
        "isOwed": "bekommt",
        "even": "ausgeglichen",
        "title": "Titel",
        "fleet": "Flotte",
        "startsAt": "Beginnt am",
        "inviteLink": "Einladungslink",
        "participants": "Personen",
        "weight": "Gewichtung",
        "shares": "Anteile",
        "customWeight": "Eigene Gewichtung",
        "preview": "Vorschau · ändert sich bis zur Abrechnung",
        "joinRequestPending": "Anfrage offen",
        "payer": "Zahler",
        "declineReason": "Grund",
        "review": {
          "pending": "Wartet auf Prüfung",
          "approved": "Freigegeben",
          "declined": "Abgelehnt"
        }
      },
      "relationships": {
        "party": "Name",
        "since": "Seit",
        "tabs": {
          "accepted": "Aktiv",
          "incoming": "Eingehend",
          "outgoing": "Gesendet",
          "ignored": "Ignoriert"
        },
        "user": {
          "handle": "Benutzername"
        },
        "fleet": {
          "handle": "Flotten-Slug"
        },
        "requested": "Anfrage gesendet",
        "friend": "Befreundet"
      },
      "blueprint": {
        "anyGrade": "Beliebige Qualität",
        "crafter": {
          "title": "Herstellen · %{name}",
          "recipe": "Bauplan %{number}",
          "noRecipe": "Für diesen Gegenstand gibt es im aktuellen Build keinen Bauplan."
        },
        "name": "Name",
        "craftTime": "Fertigungszeit",
        "slots": "Plätze",
        "materials": "Materialien",
        "quality": "Qualität",
        "missionSlots": {
          "location": "Ort",
          "objects": "Objekte",
          "target": "Ziel",
          "ship": "Schiff",
          "cargo": "Fracht",
          "rank": "Rang",
          "danger": "Gefahr",
          "contract": "Auftrag",
          "other": "variabel"
        },
        "missionSlotsHint": "Begriffe in ‹spitzen Klammern› setzt das Spiel ein, sobald der Auftrag angeboten wird.",
        "atNeutral": "%{value} bei Q500",
        "whatYouGet": "Das Ergebnis",
        "fromSlots": "%{count} Slots",
        "factorOnly": "nur Faktor — kein Katalogwert für diesen Wert",
        "heldIn": "in",
        "heldOn": "auf",
        "fromHangar": "Hangar",
        "makes": "Fertigt",
        "makesA": "Bauplan · fertigt",
        "makesUnknown": "Bauplan · fertigt etwas, das hier in keinem Katalog steht",
        "retired": "Ausgemustert",
        "minQuality": "Min. %{quality}",
        "belowGate": "Unter der Schwelle dieses Platzes — Material unter %{quality} passt hier nicht.",
        "unvalued": "betroffen — das Spiel nennt keine Werte",
        "noStats": "Dieser Platz verändert keine Werte — das Material muss nur vorhanden sein.",
        "noMaterials": "Die Spieldateien nennen keine Materialien für diesen Bauplan.",
        "setEverySlot": "Alle Plätze setzen",
        "qualityAll": "alle Plätze auf %{quality}",
        "qualityRange": "%{from}–%{to} über die Plätze",
        "anyOf": "Beliebige %{count} von diesen %{total}",
        "scu": "%{amount} SCU",
        "pieces": "%{count}×",
        "whereItDrops": "Woher er stammt",
        "fleetOwners": "Wer ihn fertigen kann",
        "ownedByCount": "%{count} besitzen ihn",
        "sourceSummary": "%{count} Quellen · %{orgs} Organisationen",
        "unattributed": "Ohne Zuordnung",
        "minPoints": "Ab %{points} Punkten",
        "limitedEvent": "Zeitlich begrenztes Event",
        "eventHint": "Event-Belohnungen gibt es nur, solange CIG das Event laufen lässt. Die Spieldateien behalten die Belohnungsstufen auch zwischen den Durchläufen, daher lässt sich daraus nicht ablesen, ob es gerade aktiv ist.",
        "noKnownSource": "Keine bekannte Quelle",
        "noSourceLead": "Keine Mission und kein Szenario vergibt diesen Bauplan.",
        "noSourceBody": "Die Spieldateien führen ihn in keinem Belohnungspool, es gibt also nichts, worauf wir verweisen könnten.",
        "empty": "Keine Baupläne gefunden.",
        "craftableTypes": {
          "Component": "Komponente",
          "Equipment": "Ausrüstung",
          "Commodity": "Ware"
        },
        "alignments": {
          "lawful": "Legal",
          "neutral": "Neutral",
          "outlaw": "Gesetzlos"
        },
        "kinds": {
          "contract": "Auftrag",
          "scenario": "Event"
        },
        "duration": {
          "hours": "%{count} Std.",
          "minutes": "%{count} Min.",
          "seconds": "%{count} Sek."
        }
      },
      "gameMission": {
        "locationNamedInText": "im Briefing genannt",
        "locations": "Wo sie stattfindet",
        "locationKinds": {
          "surface": "Auf Planet oder Mond",
          "space": "Im Weltraum",
          "mixed": "Planet, Mond oder Weltraum",
          "unknown": "Ort unbekannt"
        },
        "location": "Ort",
        "cannotLand": {
          "surface": "%{ship} kann nicht landen: Dieser Auftrag findet auf einem Planeten oder Mond statt",
          "mixed": "Kann %{ship} auf einen Planeten oder Mond führen, wo es nicht landen kann"
        },
        "calculatedInGame": "Vom Spiel berechnet",
        "blueprints": "Baupläne",
        "name": "Name",
        "org": "Angeboten von",
        "offeredBy": "Angeboten von",
        "offeredByUnknown": "Kein Auftraggeber genannt",
        "standing": "Ansehen",
        "kind": "Art",
        "kinds": {
          "career": "Karriere",
          "contract": "Einmalig"
        },
        "difficulty": "Schwierigkeit",
        "difficultyAxes": {
          "mechanicalSkill": "Mechanisches Können",
          "mentalLoad": "Geistige Last",
          "riskOfLoss": "Verlustrisiko",
          "gameKnowledge": "Spielwissen"
        },
        "alignments": {
          "lawful": "Gesetzestreu",
          "neutral": "Neutral",
          "outlaw": "Gesetzlos"
        },
        "rewards": "Belohnungen",
        "rewardKinds": {
          "blueprint": "Baupläne",
          "reputation": "Ansehen",
          "item": "Gegenstände",
          "badge": "Abzeichen",
          "currency": "Auszahlung"
        },
        "oneOfASet": "eines von mehreren",
        "briefing": "Briefing",
        "templatedNote": "Die markierten Stellen füllt das Spiel aus, wenn es die Mission vergibt.",
        "payoutNote": "Das Spiel berechnet die Auszahlung erst beim Erzeugen der Mission, deshalb nennen die Dateien nur für eine Handvoll Aufträge eine Auszahlung.",
        "noRewards": "Die Dateien nennen für diesen Auftrag keine Belohnung.",
        "handIns": "Abzugeben",
        "handInsChoice": "Eines davon",
        "buyIn": "Einsatz",
        "timeToComplete": "Dauer",
        "minutes": "%{time} Min.",
        "offeredAt": "Angeboten bei",
        "availability": {
          "orHigher": "%{standing} oder höher",
          "reputationAny": "Beliebiges Ansehen bei %{org}",
          "onceOnly": "Nur einmal",
          "thisMission": "diese Mission",
          "title": "Verfügbarkeit",
          "onePerPlayer": "Einer gleichzeitig pro Spieler",
          "perPlayer": "Bis zu %{count} gleichzeitig pro Spieler",
          "respawn": "Erneut angeboten nach %{time} Min.",
          "respawnVaried": "Erneut angeboten nach %{time} ± %{variation} Min.",
          "crimeStat": "CrimeStat %{min} – %{max}",
          "reputation": "%{band} bei %{org}",
          "reputationExcluded": "Nicht %{band} bei %{org}",
          "completeFirst": "Vorher abschließen",
          "completeCount": "%{count} davon abschließen",
          "completeUnlisted": "%{count} Missionen abschließen, die nicht im Katalog sind",
          "excluded": "Nicht mehr, sobald abgeschlossen"
        },
        "unreleased": "Nicht im Release",
        "retired": "Entfernt"
      },
      "fleetDirectory": {
        "name": "Flotten",
        "memberCount": "Mitglieder",
        "createdAt": "Neueste",
        "language": "Sprache",
        "recruiting": "Rekrutiert",
        "notRecruiting": "Rekrutiert nicht",
        "roleplay": "Rollenspiel",
        "rsiSid": "SID %{sid}"
      },
      "tour": {
        "step": "Schritt %{current} von %{total}"
      },
      "vehiclePlaque": {
        "style": "Stil",
        "styles": {
          "brass": "Messing",
          "hud": "Fleetyards-HUD",
          "gunmetal": "Rotguss",
          "blueprint": "Werft-Blaupause",
          "salvage": "Genietetes Altmetall",
          "glass": "Milchglas",
          "carbon": "Carbon & Signalrot",
          "walnut": "Nussbaum & Messing",
          "neon": "Pyro-Neon",
          "manufacturer": "Herstellerstil"
        },
        "captain": "Captain",
        "captainInfo": "Leer lassen, um dich so zu nennen, wie du in deinem öffentlichen Hangar erscheinst.",
        "registry": "Registernummer",
        "operationsGroup": "Einsatzcrew",
        "title": "Widmungstafel",
        "dedication": "Widmung",
        "dedicationVerse": "Widmungsvers",
        "dedicationVerseInfo": "Optional. Ein paar Verszeilen oder ein Segen, angezeigt, wenn jemand über die Widmung fährt oder sie antippt.",
        "launchedOn": "Stapellauf",
        "launchPort": "Starthafen",
        "affiliation": "Zugehörigkeit"
      },
      "vehicleOverview": {
        "picture": "Bild",
        "pictureInfo": "Wird anstelle des Standardbilds angezeigt, auch in deinem öffentlichen Hangar und in Flotten, mit denen du dieses Schiff teilst.",
        "ownPicture": "Dein Bild",
        "serial": "Seriennummer %{serial}",
        "since": "Im Hangar seit %{date}",
        "logSummary": "%{count} Einträge · %{public} öffentlich",
        "cargoFill": "%{stowed} von %{capacity} SCU geladen",
        "cargoStowed": "%{stowed} SCU geladen",
        "cargoMeter": "Ladung",
        "configuration": "Konfiguration",
        "noPaint": "Standardlackierung",
        "ownedPaints": "Deine Lackierungen",
        "availablePaints": "Lackierungen",
        "ownedPaintsCount": {
          "one": "%{count} Lackierung",
          "other": "%{count} Lackierungen"
        },
        "visibility": "Sichtbarkeit",
        "showPublic": "In meinem öffentlichen Hangar zeigen",
        "showName": "Namen zeigen",
        "fleets": "Im Dienst bei",
        "status": "Status",
        "searchPaints": "Lackierungen durchsuchen",
        "location": "Standort",
        "noLocation": "Nicht gesetzt",
        "noGroups": "Keine Gruppen",
        "planLoadout": "Loadout planen",
        "pictureUpload": "Hochladen",
        "pictureGallery": "Galerie",
        "stockPicture": "Standardbild",
        "waysToGetIt": "Wege zum Schiff"
      },
      "vehicleLog": {
        "entries": "Logbucheinträge",
        "title": "Titel",
        "loggedAt": "Datum",
        "loggedAtPlaceholder": "Jetzt",
        "body": "Eintrag",
        "public": "In meinem öffentlichen Hangar zeigen",
        "publicShort": "Öffentlich",
        "publicByDefault": "Neue Einträge sind öffentlich",
        "filters": {
          "all": "Alle",
          "public": "Öffentlich",
          "private": "Privat"
        },
        "entryCount": {
          "one": "%{count} Eintrag",
          "other": "%{count} Einträge"
        },
        "privateShort": "Privat",
        "stats": "Das Logbuch",
        "statsEntries": "Einträge",
        "statsPublic": "Öffentlich",
        "statsSince": "Seit"
      },
      "vehicleEdit": {
        "tabs": {
          "general": "Allgemein",
          "visibility": "Sichtbarkeit",
          "notifications": "Benachrichtigungen",
          "names": "Namen",
          "groups": "Gruppen",
          "picture": "Bild"
        }
      },
      "vehicleLoadout": {
        "tabs": {
          "paints": "Lackierungen",
          "modules": "Module",
          "upgrades": "Add-ons",
          "weapons": "Waffen",
          "missiles": "Raketen",
          "shields": "Schildgeneratoren",
          "powerPlants": "Kraftwerke",
          "coolers": "Kühler",
          "quantumDrives": "Quantum-Antriebe",
          "radar": "Radar",
          "lifeSupport": "Lebenserhaltung",
          "flightBlades": "Flugsteuerungs-Blades"
        },
        "comingSoon": "Demnächst verfügbar",
        "ownedModules": "Deine Module",
        "nothingFitted": "Nichts ausgerüstet",
        "refused": {
          "title": "Passt seit einem Spielupdate nicht mehr",
          "removedOnSave": "Beim Speichern wird das aus dem Loadout entfernt.",
          "editToReplace": "Bearbeite das Loadout, um es zu ersetzen.",
          "badge": "Passt nicht mehr",
          "reasons": {
            "slot_unknown": "das Schiff hat diesen Slot nicht mehr",
            "parent_not_fitted": "worin es saß, gibt es nicht mehr",
            "module_not_in_slot": "das Modul passt nicht mehr in diesen Slot",
            "component_not_in_slot": "passt nicht mehr in diesen Slot",
            "slot_not_editable": "das Schiff legt diesen Slot jetzt fest",
            "nothing_to_empty": "der Slot hat kein Teil mehr zum Entfernen"
          }
        },
        "againstStock": "Änderungen gegenüber dem Serienschiff",
        "crafted": "Hergestellt",
        "craftedPart": "%{name} (hergestellt)",
        "fitted": "Verbaut",
        "owned": "Im Besitz",
        "noSlots": "An diesem Schiff lässt sich hier noch nichts ausrüsten",
        "unavailableModule": "Modul nicht mehr verfügbar",
        "noFigureChange": "Ändert keine Werte des Schiffs",
        "loadoutName": "Name des Loadouts",
        "linkBuild": "Link zu einem anderswo geplanten Build",
        "stock": "Serienmäßig",
        "notFlightReady": "Loadouts gibt es nur für flugbereite Schiffe",
        "slots": {
          "default": "Modul-Slot",
          "front": "Vorderer Modul-Slot",
          "rear": "Hinterer Modul-Slot",
          "left": "Linker Modul-Slot",
          "right": "Rechter Modul-Slot"
        },
        "unavailable": {
          "modules": "Dieses Schiff nimmt keine Module auf",
          "upgrades": "Für dieses Schiff gibt es keine Add-ons"
        },
        "none": "Keine"
      },
      "loadoutPicker": {
        "emptySocket": "Leer",
        "search": "Suchen",
        "owned": "Im Besitz",
        "stock": "Serienmäßig",
        "manufacturer": "Hersteller",
        "sortName": "Name",
        "count": "%{count} von %{total}",
        "total": {
          "one": "%{count} Option",
          "other": "%{count} Optionen"
        },
        "reset": "Filter zurücksetzen",
        "leaveEmpty": "Leer lassen",
        "type": "Typ",
        "fixedByShip": "Fest verbaut",
        "noOtherPart": "Kein anderes Teil passt",
        "changed": "Geändert",
        "noMatches": "Keine Treffer",
        "close": "Schließen"
      }
    }
  }
}
